
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aGFDz", function(module, exports) {
var $36806560a48d4677$export$8b2fb347c2f49add = /*#__PURE__*/ function(AiSuggestionsEntryPointValue) {
    AiSuggestionsEntryPointValue["PRIMARY_TOOLBAR"] = "primaryToolbar";
    /**
   * @private
   * @deprecated Legacy entry point retained for backwards compatibility.
   * Use `SUGGESTIONS_PANEL_EMPTY_STATE` for the standalone suggestions panel.
   */ AiSuggestionsEntryPointValue["COMMENTS_EMPTY_STATE"] = "commentsEmptyState";
    AiSuggestionsEntryPointValue["SUGGESTIONS_PANEL_EMPTY_STATE"] = "suggestionsPanelEmptyState";
    AiSuggestionsEntryPointValue["SUGGESTIONS_PANEL_HEADER"] = "suggestionsPanelHeader";
    AiSuggestionsEntryPointValue["OBJECT_SIDEBAR_CONTROL"] = "objectSidebarControl";
    /**
   * @private
   * @deprecated Legacy automatic-generation entry point retained for backwards compatibility.
   */ AiSuggestionsEntryPointValue["SUGGESTIONS_PANEL_MOUNT"] = "suggestionsPanelMount";
    /** The "Review" button on the follow-up card after the last suggestion is actioned. */ AiSuggestionsEntryPointValue["FOLLOW_UP_CARD"] = "followUpCard";
    return AiSuggestionsEntryPointValue;
}({});
var $36806560a48d4677$export$ce4d3fb7efb5ebd7 = /*#__PURE__*/ function(AiSuggestionsRightRailEntryPointValue) {
    AiSuggestionsRightRailEntryPointValue["SUGGESTIONS_PANEL"] = "suggestionsPanel";
    AiSuggestionsRightRailEntryPointValue["SUGGESTIONS_TAB"] = "suggestionsTab";
    // Will be deprecated.
    AiSuggestionsRightRailEntryPointValue["SUGGESTION_CARD"] = "suggestionCard";
    return AiSuggestionsRightRailEntryPointValue;
}({});
var $36806560a48d4677$export$edfb4a7c9b0f2530 = /*#__PURE__*/ function(AiSuggestionsRegenerationTriggerValue) {
    AiSuggestionsRegenerationTriggerValue["PANEL_OPEN"] = "panelOpen";
    AiSuggestionsRegenerationTriggerValue["REVIEW_COMPLETED"] = "reviewCompleted";
    AiSuggestionsRegenerationTriggerValue["SUGGESTION_SELECTED"] = "suggestionSelected";
    AiSuggestionsRegenerationTriggerValue["SUGGESTIONS_UPDATED"] = "suggestionsUpdated";
    return AiSuggestionsRegenerationTriggerValue;
}({});
var $36806560a48d4677$export$d51545309fb621fd = /*#__PURE__*/ function(AiSuggestionsRegenerationOutcomeValue) {
    AiSuggestionsRegenerationOutcomeValue["REMOVED"] = "removed";
    AiSuggestionsRegenerationOutcomeValue["STILL_STALE"] = "stillStale";
    AiSuggestionsRegenerationOutcomeValue["UPDATED"] = "updated";
    return AiSuggestionsRegenerationOutcomeValue;
}({});
module.exports["AiSuggestionsEntryPointValue"] = $36806560a48d4677$export$8b2fb347c2f49add;
module.exports["AiSuggestionsRightRailEntryPointValue"] = $36806560a48d4677$export$ce4d3fb7efb5ebd7;
module.exports["AiSuggestionsRegenerationTriggerValue"] = $36806560a48d4677$export$edfb4a7c9b0f2530;
module.exports["AiSuggestionsRegenerationOutcomeValue"] = $36806560a48d4677$export$d51545309fb621fd;

});

parcelRegister("hpxac", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $bQm3c = parcelRequire("bQm3c");


var $iISzu = parcelRequire("iISzu");


var $3IuoM = parcelRequire("3IuoM");


var $cQTQm = parcelRequire("cQTQm");


var $4u4Rn = parcelRequire("4u4Rn");

const $dffed8a38e0fa515$var$i18n = (0, $kSwu1.defineMessages)({
    suggestionsPanelHeaderLabel: {
        id: "suggestions-panel.panel.header.review-suggestions.label",
        defaultMessage: "Review suggestions"
    }
});
const $dffed8a38e0fa515$export$52ffbce15fbad734 = ()=>{
    const $ = (0, $bDgLe.c)(11);
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar, changePanel: changePanel } = (0, $aWwYt.useObjectSidebarActions)();
    const { cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== changePanel || $[1] !== cloudId || $[2] !== isAIEarlyAccessEnabled || $[3] !== isAdminHubAIEnabled || $[4] !== isObjectSidebarShown || $[5] !== showObjectSidebar) {
        t0 = (t1)=>{
            const { entryPoint: entryPoint, publishedContentId: publishedContentId } = t1 === undefined ? {} : t1;
            if (!isAdminHubAIEnabled || !isAIEarlyAccessEnabled) return;
            if (publishedContentId && (0, $6mKj3.expValEquals)("platform_editor_ai_content_suggested_edits", "isEnabled", true) && (0, $9wGTI.fg)("confluence_suggestions_panel_view_mode")) (0, $iISzu.startPublishedSuggestions)(publishedContentId, cloudId);
            const suggestionsPanel = {
                id: (0, $jvYFk.PanelName).SuggestionsPanel,
                headerComponentElements: {
                    headerLabel: $dffed8a38e0fa515$var$i18n.suggestionsPanelHeaderLabel,
                    HeaderAfterIconElement: (0, $cQTQm.SuggestionsCount),
                    HeaderRightAlignedElement: (0, $4u4Rn.SuggestionsHeaderActionGroup)
                },
                BodyComponent: ()=>(0, $cozmU.createElement)((0, $3IuoM.SuggestionsPanelLayout), {
                        entryPoint: entryPoint
                    }),
                closeOptions: {
                    onPanelClose: (0, $iISzu.resetPublishedSuggestions)
                }
            };
            if (isObjectSidebarShown) {
                changePanel(suggestionsPanel, "push");
                return;
            }
            showObjectSidebar(suggestionsPanel, "push");
        };
        $[0] = changePanel;
        $[1] = cloudId;
        $[2] = isAIEarlyAccessEnabled;
        $[3] = isAdminHubAIEnabled;
        $[4] = isObjectSidebarShown;
        $[5] = showObjectSidebar;
        $[6] = t0;
    } else t0 = $[6];
    const showSuggestionsPanel = t0;
    const t1 = isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).SuggestionsPanel;
    let t2;
    if ($[7] !== hideObjectSidebar || $[8] !== showSuggestionsPanel || $[9] !== t1) {
        t2 = {
            isSuggestionsPanelShown: t1,
            showSuggestionsPanel: showSuggestionsPanel,
            hideSuggestionsPanel: hideObjectSidebar
        };
        $[7] = hideObjectSidebar;
        $[8] = showSuggestionsPanel;
        $[9] = t1;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
};
module.exports["useShowSuggestionsPanel"] = $dffed8a38e0fa515$export$52ffbce15fbad734;

});

parcelRegister("iISzu", function(module, exports) {

var $2ZgNf = parcelRequire("2ZgNf");


var $gS0UM = parcelRequire("gS0UM");

const $506822c276cf6b58$var$initialState = {
    status: 'idle',
    suggestions: []
};
const $506822c276cf6b58$export$a17c7748ca670edb = 120000;
let $506822c276cf6b58$var$snapshot = $506822c276cf6b58$var$initialState;
let $506822c276cf6b58$var$abortController;
let $506822c276cf6b58$var$cache;
const $506822c276cf6b58$var$getFreshCachedSuggestions = (contentId, cloudId)=>$506822c276cf6b58$var$cache && $506822c276cf6b58$var$cache.contentId === contentId && $506822c276cf6b58$var$cache.cloudId === cloudId && Date.now() - $506822c276cf6b58$var$cache.loadedAt < $506822c276cf6b58$export$a17c7748ca670edb ? $506822c276cf6b58$var$cache.suggestions : undefined;
const $506822c276cf6b58$var$listeners = new Set();
const $506822c276cf6b58$var$setSnapshot = (next)=>{
    $506822c276cf6b58$var$snapshot = next;
    $506822c276cf6b58$var$listeners.forEach((listener)=>listener());
};
const $506822c276cf6b58$export$a7a6ac793e132e51 = (onStoreChange)=>{
    $506822c276cf6b58$var$listeners.add(onStoreChange);
    return ()=>{
        $506822c276cf6b58$var$listeners.delete(onStoreChange);
    };
};
const $506822c276cf6b58$export$2c08c2349747e399 = ()=>$506822c276cf6b58$var$snapshot;
const $506822c276cf6b58$export$1b63cb91f4088d7e = ()=>$506822c276cf6b58$var$initialState;
const $506822c276cf6b58$export$d7d691bc3198137 = (contentId, cloudId)=>{
    $506822c276cf6b58$var$abortController?.abort();
    $506822c276cf6b58$var$abortController = undefined;
    const cachedSuggestions = $506822c276cf6b58$var$getFreshCachedSuggestions(contentId, cloudId);
    if (cachedSuggestions) {
        $506822c276cf6b58$var$setSnapshot({
            contentId: contentId,
            status: 'loaded',
            suggestions: cachedSuggestions
        });
        return;
    }
    const controller = new AbortController();
    $506822c276cf6b58$var$abortController = controller;
    $506822c276cf6b58$var$setSnapshot({
        contentId: contentId,
        status: 'loading',
        suggestions: []
    });
    const { signal: signal } = controller;
    Promise.all([
        (0, $gS0UM.fetchPublishedPageSuggestions)({
            cloudId: cloudId,
            contentId: contentId,
            signal: signal
        }),
        (0, $gS0UM.fetchLatestDraftAdf)({
            contentId: contentId,
            signal: signal
        }).catch(()=>undefined)
    ]).then(([fetchedSuggestions, latestDraftAdf])=>{
        if ($506822c276cf6b58$var$abortController !== controller) return;
        $506822c276cf6b58$var$abortController = undefined;
        let suggestions = fetchedSuggestions;
        if (latestDraftAdf) try {
            suggestions = (0, $2ZgNf.orderSuggestionsByDocument)(fetchedSuggestions, latestDraftAdf);
        } catch  {}
        $506822c276cf6b58$var$cache = {
            cloudId: cloudId,
            contentId: contentId,
            suggestions: suggestions,
            loadedAt: Date.now()
        };
        $506822c276cf6b58$var$setSnapshot({
            ...$506822c276cf6b58$var$snapshot,
            status: 'loaded',
            suggestions: suggestions
        });
    }, ()=>{
        if ($506822c276cf6b58$var$abortController !== controller) return;
        $506822c276cf6b58$var$abortController = undefined;
        $506822c276cf6b58$var$setSnapshot({
            ...$506822c276cf6b58$var$snapshot,
            status: 'error',
            suggestions: []
        });
    });
};
const $506822c276cf6b58$export$642fe99fc95d2682 = (contentId)=>{
    if ($506822c276cf6b58$var$cache?.contentId === contentId) $506822c276cf6b58$var$cache = undefined;
};
const $506822c276cf6b58$export$875ae631b813d0e0 = (suggestionId)=>{
    if ($506822c276cf6b58$var$snapshot.contentId === undefined || $506822c276cf6b58$var$snapshot.selectedSuggestionId === suggestionId) return;
    $506822c276cf6b58$var$setSnapshot({
        ...$506822c276cf6b58$var$snapshot,
        selectedSuggestionId: suggestionId
    });
};
const $506822c276cf6b58$export$985196fc1c1588db = ()=>{
    if ($506822c276cf6b58$var$snapshot.contentId === undefined || $506822c276cf6b58$var$snapshot.shouldStartReviewInEditMode) return;
    $506822c276cf6b58$var$setSnapshot({
        ...$506822c276cf6b58$var$snapshot,
        shouldStartReviewInEditMode: true
    });
};
const $506822c276cf6b58$export$6d341b7a73e1de4f = ()=>{
    $506822c276cf6b58$var$abortController?.abort();
    $506822c276cf6b58$var$abortController = undefined;
    if ($506822c276cf6b58$var$snapshot !== $506822c276cf6b58$var$initialState) $506822c276cf6b58$var$setSnapshot($506822c276cf6b58$var$initialState);
};
const $506822c276cf6b58$export$99a5c6da72f0844c = ()=>{
    $506822c276cf6b58$var$abortController?.abort();
    $506822c276cf6b58$var$abortController = undefined;
    $506822c276cf6b58$var$cache = undefined;
    $506822c276cf6b58$var$snapshot = $506822c276cf6b58$var$initialState;
    $506822c276cf6b58$var$listeners.clear();
};
module.exports["subscribeToPublishedSuggestions"] = $506822c276cf6b58$export$a7a6ac793e132e51;
module.exports["getPublishedSuggestionsSnapshot"] = $506822c276cf6b58$export$2c08c2349747e399;
module.exports["getInitialPublishedSuggestionsSnapshot"] = $506822c276cf6b58$export$1b63cb91f4088d7e;
module.exports["startPublishedSuggestions"] = $506822c276cf6b58$export$d7d691bc3198137;
module.exports["invalidatePublishedSuggestionsCache"] = $506822c276cf6b58$export$642fe99fc95d2682;
module.exports["selectPublishedSuggestion"] = $506822c276cf6b58$export$875ae631b813d0e0;
module.exports["requestPublishedReviewInEditMode"] = $506822c276cf6b58$export$985196fc1c1588db;
module.exports["resetPublishedSuggestions"] = $506822c276cf6b58$export$6d341b7a73e1de4f;

});

parcelRegister("2ZgNf", function(module, exports) {
const $a6173cfe46c76fa1$var$getAnchorLocalId = (suggestion)=>{
    if (suggestion.anchorLocalId) return suggestion.anchorLocalId;
    const firstToolCall = suggestion.toolCalls?.[0];
    if (!firstToolCall || !('localId' in firstToolCall.arguments)) return undefined;
    const { localId: localId } = firstToolCall.arguments;
    return typeof localId === 'string' && localId ? localId : undefined;
};
const $a6173cfe46c76fa1$var$getLocalId = (node)=>typeof node.attrs?.localId === 'string' && node.attrs.localId ? node.attrs.localId : undefined;
const $a6173cfe46c76fa1$export$2f93fbb7e786a466 = (suggestions, doc)=>{
    const suggestionsByAnchorLocalId = new Map();
    for (const suggestion of suggestions){
        const anchorLocalId = $a6173cfe46c76fa1$var$getAnchorLocalId(suggestion);
        if (anchorLocalId) {
            const anchored = suggestionsByAnchorLocalId.get(anchorLocalId) ?? [];
            anchored.push(suggestion);
            suggestionsByAnchorLocalId.set(anchorLocalId, anchored);
        }
    }
    const ordered = [];
    const placedSuggestionIds = new Set();
    const visit = (node, topLevelBlockLocalId)=>{
        const localId = $a6173cfe46c76fa1$var$getLocalId(node);
        const anchored = localId ? suggestionsByAnchorLocalId.get(localId) : undefined;
        if (anchored && topLevelBlockLocalId) {
            for (const suggestion of anchored)if (!placedSuggestionIds.has(suggestion.id)) {
                placedSuggestionIds.add(suggestion.id);
                ordered.push(suggestion);
            }
        }
        node.content?.forEach((child)=>visit(child, topLevelBlockLocalId));
    };
    doc.content?.forEach((topLevelBlock)=>visit(topLevelBlock, $a6173cfe46c76fa1$var$getLocalId(topLevelBlock)));
    return ordered;
};
module.exports["orderSuggestionsByDocument"] = $a6173cfe46c76fa1$export$2f93fbb7e786a466;

});

parcelRegister("gS0UM", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");

const $c2d08ca13bd9a039$var$fetchContentAdf = async ({ contentId: contentId, status: status, signal: signal })=>{
    let response;
    try {
        response = await (0, $f7B1p.cfetch)(`/wiki/rest/api/content/${encodeURIComponent(contentId)}?status=${status}&expand=body.atlas_doc_format`, {
            method: 'GET',
            credentials: 'include',
            signal: signal,
            ignoreNoNetworkError: true
        });
    } catch (error) {
        if ((0, $hBkCm.BadStatusError).isBadStatusError(error) && error.response.status === 404) return null;
        throw error;
    }
    const data = await response.json();
    const value = data?.body?.atlas_doc_format?.value;
    if (!value) throw new Error(`Get ${status} content response has no ADF body`);
    return JSON.parse(value);
};
const $c2d08ca13bd9a039$export$f7b3bfed53021ed2 = async ({ contentId: contentId, signal: signal })=>{
    const draft = await $c2d08ca13bd9a039$var$fetchContentAdf({
        contentId: contentId,
        status: 'draft',
        signal: signal
    });
    if (draft) return draft;
    const current = await $c2d08ca13bd9a039$var$fetchContentAdf({
        contentId: contentId,
        status: 'current',
        signal: signal
    });
    if (!current) throw new Error('Get content request failed: 404');
    return current;
};
const $c2d08ca13bd9a039$export$6a2f2c83863e9bfe = (cloudId, contentId)=>`ari:cloud:confluence:${cloudId}:page/${contentId}`;
const $c2d08ca13bd9a039$export$3e6f4c947633bafa = async ({ cloudId: cloudId, contentId: contentId, signal: signal })=>{
    const contentAri = $c2d08ca13bd9a039$export$6a2f2c83863e9bfe(cloudId, contentId);
    const url = `/gateway/api/assist/api/ai/v2/ai-feature/content-suggested-edits/suggestions?content_ari=${encodeURIComponent(contentAri)}&status=PENDING`;
    const response = await (0, $f7B1p.cfetch)(url, {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Channel-Id': 'editor',
            'X-Product': 'confluence',
            'X-Experience-Id': 'editor'
        },
        signal: signal,
        ignoreNoNetworkError: true
    });
    const data = await response.json();
    const items = data?.ai_feature_output?.items;
    return Array.isArray(items) ? items : [];
};
module.exports["fetchLatestDraftAdf"] = $c2d08ca13bd9a039$export$f7b3bfed53021ed2;
module.exports["fetchPublishedPageSuggestions"] = $c2d08ca13bd9a039$export$3e6f4c947633bafa;

});

parcelRegister("3IuoM", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $de2j9 = parcelRequire("de2j9");


var $jPGwc = parcelRequire("jPGwc");


var $fsI2i = parcelRequire("fsI2i");


var $5kr5S = parcelRequire("5kr5S");

const $8c4ce0e564e3f53d$var$styles = {
    layout: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _1mT5xdRAKS",
    panelSystem: "_49OCfRdnbC _1mT5xdWVPG",
    content: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAIZbP _2WAcuGIZbP _4kiQYAdnbC _0xmtkoqXih _0PqAlkqXih",
    footerOverlay: "_1mT5xdWVPG _1ZB6UydnbC _3iC0zddnbC _1OKFqYdnbC"
};
const $8c4ce0e564e3f53d$export$71d5cc5bf1b3380f = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { entryPoint: entryPoint } = t0;
    const mode = (0, $jPGwc.useSuggestionsSourceMode)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const [isContinuingFromPublished, setIsContinuingFromPublished] = (0, $cozmU.useState)(false);
    if (!isContinuingFromPublished && mode === "published" && isEditorPage) setIsContinuingFromPublished(true);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $8c4ce0e564e3f53d$var$styles.layout,
            (0, $9wGTI.fg)("ads-panel-system-confluence-object-sidebar") && $8c4ce0e564e3f53d$var$styles.panelSystem
        ]);
        t2 = (0, $hekY6.default)([
            $8c4ce0e564e3f53d$var$styles.content
        ]);
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== entryPoint || $[3] !== isContinuingFromPublished || $[4] !== mode) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fsI2i.SuggestionsPanel), {
            key: mode,
            entryPoint: entryPoint,
            isStackEntranceSkipped: isContinuingFromPublished
        }));
        $[2] = entryPoint;
        $[3] = isContinuingFromPublished;
        $[4] = mode;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $8c4ce0e564e3f53d$var$styles.footerOverlay
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5kr5S.SuggestionsFooter), null));
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, t3, t4);
        $[7] = t3;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
};
module.exports["SuggestionsPanelLayout"] = $8c4ce0e564e3f53d$export$71d5cc5bf1b3380f;

});

parcelRegister("jPGwc", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $3k5Tv = parcelRequire("3k5Tv");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $kDhla = parcelRequire("kDhla");


var $iISzu = parcelRequire("iISzu");


var $kJr0V = parcelRequire("kJr0V");

const $88665a9b50459ae3$var$getOrderedSuggestions = (aiSuggestionsState)=>{
    const suggestions = [];
    for (const id of aiSuggestionsState.orderedSuggestionIds){
        const suggestion = aiSuggestionsState.suggestionById.get(id);
        if (suggestion !== undefined) suggestions.push(suggestion);
    }
    return suggestions;
};
const $88665a9b50459ae3$export$8122524d586b84c5 = ()=>{
    const { contentId: contentId } = (0, $kJr0V.usePublishedSuggestionsState)();
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    if ((contentId !== undefined || !fullPageEditorPresetAPI) && (0, $6mKj3.expValEquals)("platform_editor_ai_content_suggested_edits", "isEnabled", true) && (0, $9wGTI.fg)("confluence_suggestions_panel_view_mode")) return "published";
    return "editor";
};
const $88665a9b50459ae3$export$a842903cb8549d63 = ()=>{
    const $ = (0, $bDgLe.c)(26);
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const mode = $88665a9b50459ae3$export$8122524d586b84c5();
    const publishedState = (0, $kJr0V.usePublishedSuggestionsState)();
    const editorAPI = mode === "editor" ? fullPageEditorPresetAPI : undefined;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "aiSuggestions"
        ];
        $[0] = t0;
    } else t0 = $[0];
    const editorState = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorAPI, t0, $88665a9b50459ae3$var$_temp);
    let t1;
    if ($[1] !== editorAPI?.aiSuggestions?.actions || $[2] !== mode) {
        t1 = (suggestionId)=>{
            if (mode === "published") {
                (0, $iISzu.selectPublishedSuggestion)(suggestionId);
                return;
            }
            editorAPI?.aiSuggestions?.actions.selectSuggestion(suggestionId ?? null, {
                interactionPoint: "sidebar"
            });
        };
        $[1] = editorAPI?.aiSuggestions?.actions;
        $[2] = mode;
        $[3] = t1;
    } else t1 = $[3];
    const selectSuggestion = t1;
    if (mode === "published") {
        const t2 = publishedState.status === "idle" || publishedState.status === "loading";
        const t3 = publishedState.status === "error";
        let t4;
        if ($[4] !== publishedState.selectedSuggestionId || $[5] !== publishedState.suggestions || $[6] !== selectSuggestion || $[7] !== t2 || $[8] !== t3) {
            t4 = {
                mode: "published",
                count: publishedState.suggestions.length,
                suggestions: publishedState.suggestions,
                selectedSuggestionId: publishedState.selectedSuggestionId,
                selectSuggestion: selectSuggestion,
                isThinking: false,
                thinking: undefined,
                isInitialising: t2,
                hasError: t3,
                editorAPI: undefined
            };
            $[4] = publishedState.selectedSuggestionId;
            $[5] = publishedState.suggestions;
            $[6] = selectSuggestion;
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t2;
    if ($[10] !== editorState.suggestions) {
        t2 = editorState?.suggestions ?? [];
        $[10] = editorState.suggestions;
        $[11] = t2;
    } else t2 = $[11];
    const editorSuggestions = t2;
    const t3 = editorState.thinkingStatus === "thinking";
    let t4;
    if ($[12] !== editorState.regeneratingSuggestionIds || $[13] !== editorState.reviewingAgent || $[14] !== editorState.thinkingAgentReadyAt || $[15] !== editorState.thinkingProgressTarget || $[16] !== editorState.thinkingStartedAt || $[17] !== editorState.thinkingStatus) {
        t4 = {
            status: editorState.thinkingStatus,
            startedAt: editorState.thinkingStartedAt,
            progressTarget: editorState.thinkingProgressTarget,
            agentReadyAt: editorState.thinkingAgentReadyAt,
            reviewingAgent: editorState.reviewingAgent,
            regeneratingSuggestionIds: editorState.regeneratingSuggestionIds
        };
        $[12] = editorState.regeneratingSuggestionIds;
        $[13] = editorState.reviewingAgent;
        $[14] = editorState.thinkingAgentReadyAt;
        $[15] = editorState.thinkingProgressTarget;
        $[16] = editorState.thinkingStartedAt;
        $[17] = editorState.thinkingStatus;
        $[18] = t4;
    } else t4 = $[18];
    let t5;
    if ($[19] !== editorAPI || $[20] !== editorState.selectedSuggestionId || $[21] !== editorSuggestions || $[22] !== selectSuggestion || $[23] !== t3 || $[24] !== t4) {
        t5 = {
            mode: "editor",
            count: editorSuggestions.length,
            suggestions: editorSuggestions,
            selectedSuggestionId: editorState.selectedSuggestionId,
            selectSuggestion: selectSuggestion,
            isThinking: t3,
            thinking: t4,
            isInitialising: false,
            hasError: false,
            editorAPI: editorAPI
        };
        $[19] = editorAPI;
        $[20] = editorState.selectedSuggestionId;
        $[21] = editorSuggestions;
        $[22] = selectSuggestion;
        $[23] = t3;
        $[24] = t4;
        $[25] = t5;
    } else t5 = $[25];
    return t5;
};
function $88665a9b50459ae3$var$_temp(t0) {
    const { aiSuggestionsState: aiSuggestionsState } = t0;
    return {
        suggestions: aiSuggestionsState ? $88665a9b50459ae3$var$getOrderedSuggestions(aiSuggestionsState) : [],
        selectedSuggestionId: aiSuggestionsState?.selectedSuggestion,
        thinkingStatus: aiSuggestionsState?.thinkingStatus,
        thinkingStartedAt: aiSuggestionsState?.thinkingStartedAt ?? null,
        thinkingProgressTarget: aiSuggestionsState?.thinkingProgressTarget ?? null,
        thinkingAgentReadyAt: aiSuggestionsState?.thinkingAgentReadyAt ?? null,
        reviewingAgent: aiSuggestionsState?.reviewingAgent ?? undefined,
        regeneratingSuggestionIds: aiSuggestionsState?.regeneratingSuggestionIds
    };
}
module.exports["useSuggestionsSourceMode"] = $88665a9b50459ae3$export$8122524d586b84c5;
module.exports["useSuggestionsSource"] = $88665a9b50459ae3$export$a842903cb8549d63;

});

parcelRegister("kJr0V", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iISzu = parcelRequire("iISzu");

const $ee93499f21330113$export$b64ed6eb8b012c50 = ()=>{
    return (0, $cozmU.useSyncExternalStore)((0, $iISzu.subscribeToPublishedSuggestions), (0, $iISzu.getPublishedSuggestionsSnapshot), (0, $iISzu.getInitialPublishedSuggestionsSnapshot));
};
module.exports["usePublishedSuggestionsState"] = $ee93499f21330113$export$b64ed6eb8b012c50;

});

parcelRegister("fsI2i", function(module, exports) {
/* SuggestionsPanel.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4aRua = parcelRequire("4aRua");


var $aGFDz = parcelRequire("aGFDz");





var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $2gVZP = parcelRequire("2gVZP");


var $lXxb6 = parcelRequire("lXxb6");


var $73rWB = parcelRequire("73rWB");


var $71PZp = parcelRequire("71PZp");


var $jPGwc = parcelRequire("jPGwc");


var $ifwMO = parcelRequire("ifwMO");


var $fEpsr = parcelRequire("fEpsr");


var $anzFm = parcelRequire("anzFm");


var $ap8M1 = parcelRequire("ap8M1");


var $hkoM6 = parcelRequire("hkoM6");


var $H1gk2 = parcelRequire("H1gk2");


var $3Kj0o = parcelRequire("3Kj0o");

const $53ea9a41ca4eb886$var$i18n = (0, $kSwu1.defineMessages)({
    errorMessage: {
        id: "suggestions-panel.published.error.message",
        defaultMessage: "We couldn\u2019t load suggestions. Try again later."
    }
});
const $53ea9a41ca4eb886$var$styles = {
    panelContainer: "_2mHwu85zaO _4c065U2ADO _2Y7lL4kG2W _24h04i2Njc _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAN91d"
};
const $53ea9a41ca4eb886$var$emptyStateAnalyticsTypes = {
    initial: 'initial',
    noSuggestionsResult: 'noSuggestionsFound',
    allResolved: 'suggestionsResolved'
};
const $53ea9a41ca4eb886$export$108b4a99093fdc66 = ({ entryPoint: entryPoint = (0, $aGFDz.AiSuggestionsRightRailEntryPointValue).SUGGESTIONS_PANEL, isStackEntranceSkipped: isStackEntranceSkipped = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { mode: mode, suggestions: suggestions, selectedSuggestionId: selectedSuggestionId, selectSuggestion: selectSuggestion, thinking: thinking, isInitialising: isInitialising, hasError: hasError, editorAPI: fullPageEditorPresetAPI } = (0, $jPGwc.useSuggestionsSource)();
    const isPublishedMode = mode === 'published';
    const published = (0, $lXxb6.usePublishedSuggestionsPanel)(isPublishedMode);
    const thinkingStatus = thinking?.status;
    const thinkingStartedAt = thinking?.startedAt ?? null;
    const thinkingProgressTarget = thinking?.progressTarget ?? null;
    const regeneratingSuggestionIds = thinking?.regeneratingSuggestionIds;
    const reviewingAgent = thinking?.reviewingAgent; // Names the agent in the loading copy. `undefined` until the plugin resolves it
    // (or when no agent handles the review), which the loading states treat as
    // "fall back to the generic Rovo copy".
    const reviewingAgentName = reviewingAgent?.name || undefined;
    const isAgentLoading = // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    thinkingStatus === 'thinking' && !reviewingAgent && (0, $9wGTI.fg)('content_reviewer_agent');
    const loadingRotationStartedAt = thinking?.agentReadyAt ?? thinkingStartedAt; /**
                                                                                 * Bring the list up to date whenever the panel opens — this component is only
                                                                                 * rendered while the Suggestions panel is active, so a mount *is* the panel being
                                                                                 * opened (and covers the sidebar being opened straight onto this panel, which a
                                                                                 * panel-change listener would miss).
                                                                                 *
                                                                                 * Suggestions already in state get their staleness re-checked after however
                                                                                 * much editing happened while the panel was closed. An empty panel remains idle
                                                                                 * until the user explicitly starts Review from its empty state.
                                                                                 */ 
    (0, $cozmU.useEffect)(()=>{
        // Keyed on the api rather than mount-only because it can be absent on the
        // first render if the editor isn't ready yet. It's a stable reference for the
        // life of an editor instance, so this runs once per open.
        const aiSuggestions = fullPageEditorPresetAPI?.aiSuggestions;
        if (!aiSuggestions) return;
         // Read through the api rather than the debounced hook state, which can still
        // hold a value from before the panel opened.
        const state = aiSuggestions.sharedState.currentState(); // A generation is already running (e.g. started from the sidebar control
        // that opened this panel) — it refreshes the list when it lands.
        if (state?.thinkingStatus === 'thinking') return;
        if ((state?.orderedSuggestionIds.length ?? 0) === 0) return;
         // Regenerate-only: a full refresh would re-fetch, which reorders the list and
        // can resurrect suggestions whose accept/discard status update is in flight.
        aiSuggestions.actions.refreshSuggestions({
            regenerateOnly: true,
            regenerationTrigger: (0, $aGFDz.AiSuggestionsRegenerationTriggerValue).PANEL_OPEN
        });
    }, [
        fullPageEditorPresetAPI
    ]);
    const [{ currentFilter: currentFilter, currentSort: currentSort }] = (0, $71PZp.useSuggestionsPanelFilters)();
    const { userId: userId } = (0, $bQm3c.useSessionData)(); // The header's filter menu drives what the list shows. Analytics and the regeneration latch
    // below deliberately keep reading the unfiltered list — they describe the document, not the
    // user's current view of it.
    const visibleSuggestions = (0, $cozmU.useMemo)(()=>(0, $73rWB.getVisibleSuggestions)(suggestions, {
            currentFilter: currentFilter,
            currentSort: currentSort,
            currentUserId: userId
        }), [
        suggestions,
        currentFilter,
        currentSort,
        userId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (selectedSuggestionId && visibleSuggestions && !visibleSuggestions.some((suggestion)=>suggestion.id === selectedSuggestionId)) selectSuggestion(undefined);
    }, [
        selectSuggestion,
        selectedSuggestionId,
        visibleSuggestions
    ]);
    const hasSuggestions = (visibleSuggestions?.length ?? 0) > 0;
    const hasPendingSuggestions = (suggestions?.length ?? 0) > 0;
    const hasRenderedLoadingStateRef = (0, $cozmU.useRef)(false);
    const hadPendingSuggestionsRef = (0, $cozmU.useRef)(hasPendingSuggestions);
    const [emptyVariant, setEmptyVariant] = (0, $cozmU.useState)('initial');
    const isEmptyStateTransitionPending = !hasPendingSuggestions && (thinkingStatus === 'complete' && hasRenderedLoadingStateRef.current || hadPendingSuggestionsRef.current); // Latch for the inline loading bar. `thinkingStatus` can flip
    // 'thinking' -> 'complete' in one React commit batch, so we latch on when
    // thinking starts and release once the regenerated suggestions arrive.
    const [isRegenerating, setIsRegenerating] = (0, $cozmU.useState)(false);
    const suggestionIdsKey = (suggestions ?? []).map((s)=>s?.id).join(',');
    const suggestionIdsKeyAtRegenStartRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const clearedSuggestions = hadPendingSuggestionsRef.current && !hasPendingSuggestions;
        hadPendingSuggestionsRef.current = hasPendingSuggestions;
        const completedReview = thinkingStatus === 'complete' && hasRenderedLoadingStateRef.current;
        hasRenderedLoadingStateRef.current = thinkingStatus === 'thinking';
        if (hasPendingSuggestions) setEmptyVariant('initial');
        else if (completedReview) setEmptyVariant('noSuggestionsResult');
        else if (clearedSuggestions) setEmptyVariant('allResolved');
    }, [
        hasPendingSuggestions,
        thinkingStatus
    ]); // Manage the inline loading-bar latch (see comment above).
    (0, $cozmU.useEffect)(()=>{
        if (thinkingStatus === 'thinking') {
            // Remember the current set so we can detect when new results arrive.
            suggestionIdsKeyAtRegenStartRef.current = suggestionIdsKey;
            setIsRegenerating(true);
            return;
        }
        if (thinkingStatus === 'idle') {
            // Cancelled / reset.
            suggestionIdsKeyAtRegenStartRef.current = null;
            setIsRegenerating(false);
            return;
        } // 'complete': keep the bar until new suggestions arrive (id set changes),
        // with a safety timeout so it can't get stuck if the set is unchanged/empty.
        if (!isRegenerating) return;
        if (suggestionIdsKey !== suggestionIdsKeyAtRegenStartRef.current) {
            suggestionIdsKeyAtRegenStartRef.current = null;
            setIsRegenerating(false);
            return;
        }
        const timeoutId = setTimeout(()=>{
            suggestionIdsKeyAtRegenStartRef.current = null;
            setIsRegenerating(false);
        }, 500);
        return ()=>clearTimeout(timeoutId);
    }, [
        thinkingStatus,
        suggestionIdsKey,
        isRegenerating
    ]);
    const navigationTimeoutRef = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>()=>clearTimeout(navigationTimeoutRef.current), []);
    const handleSelect = (0, $cozmU.useCallback)((id)=>selectSuggestion(selectedSuggestionId === id ? undefined : id), [
        selectSuggestion,
        selectedSuggestionId
    ]);
    const selectNextSuggestion = (0, $cozmU.useCallback)((id_0)=>{
        clearTimeout(navigationTimeoutRef.current);
        if (!visibleSuggestions || visibleSuggestions.length < 2) return;
        const index = visibleSuggestions.findIndex((suggestion_0)=>suggestion_0.id === id_0);
        if (index === -1) return;
         // Use the rail's order before removal, including its current filter and sort.
        const nextSuggestion = visibleSuggestions[(index + 1) % visibleSuggestions.length];
        const selectNext = ()=>{
            fullPageEditorPresetAPI?.aiSuggestions?.actions.selectSuggestion(nextSuggestion.id, {
                interactionPoint: 'sidebar'
            });
        };
        if ((0, $6mKj3.isExperimentEnabled)('platform_editor_ai_content_suggested_edits_labs')) {
            const acceptShimmerDuration = fullPageEditorPresetAPI?.aiSuggestions?.sharedState.currentState()?.acceptShimmerDuration ?? 0;
            navigationTimeoutRef.current = setTimeout(selectNext, acceptShimmerDuration);
        } else selectNext();
    }, [
        fullPageEditorPresetAPI,
        visibleSuggestions
    ]);
    const handleAccept = (0, $cozmU.useCallback)((id_1, isDiffHidden)=>{
        if (fullPageEditorPresetAPI?.aiSuggestions?.actions.acceptSuggestion(id_1, 'sidebar', isDiffHidden)) selectNextSuggestion(id_1);
    }, [
        fullPageEditorPresetAPI,
        selectNextSuggestion
    ]);
    const handleDiscard = (0, $cozmU.useCallback)((id_2)=>{
        if (fullPageEditorPresetAPI?.aiSuggestions?.actions.discardSuggestion(id_2)) selectNextSuggestion(id_2);
    }, [
        fullPageEditorPresetAPI,
        selectNextSuggestion
    ]);
    const handleDismiss = (0, $cozmU.useCallback)((id_3)=>{
        fullPageEditorPresetAPI?.aiSuggestions?.actions.discardSuggestion(id_3);
    }, [
        fullPageEditorPresetAPI
    ]);
    const handleGoodSuggestion = (0, $cozmU.useCallback)((id_4)=>{
        fullPageEditorPresetAPI?.aiSuggestions?.actions.submitSuggestionFeedback(id_4, 'good', {
            interactionPoint: 'sidebar'
        });
    }, [
        fullPageEditorPresetAPI
    ]);
    const handleBadSuggestion = (0, $cozmU.useCallback)((id_5)=>{
        fullPageEditorPresetAPI?.aiSuggestions?.actions.submitSuggestionFeedback(id_5, 'bad', {
            interactionPoint: 'sidebar'
        });
    }, [
        fullPageEditorPresetAPI
    ]);
    const handleToggleDeletedDiffs = (0, $cozmU.useCallback)((id_6, hideDeletedDiffs)=>{
        fullPageEditorPresetAPI?.aiSuggestions?.actions.selectSuggestion(id_6, {
            hideDeletedDiffs: hideDeletedDiffs,
            scrollIntoView: false
        });
    }, [
        fullPageEditorPresetAPI
    ]); // Only animate cards already visible when the sidebar opens, not suggestions created later.
    const [isStackAnimating, setIsStackAnimating] = (0, $cozmU.useState)(()=>!isStackEntranceSkipped && (visibleSuggestions?.length ?? 0) > 1);
    const handleAnimationComplete = (0, $cozmU.useCallback)(()=>setIsStackAnimating(false), []);
    const [wasInitialising, setWasInitialising] = (0, $cozmU.useState)(isInitialising);
    if (wasInitialising !== isInitialising) {
        setWasInitialising(isInitialising);
        if (!isInitialising) setIsStackAnimating(!isStackEntranceSkipped && (visibleSuggestions?.length ?? 0) > 1);
    }
    const isThinking = thinkingStatus === 'thinking';
    const showInlineLoadingBar = isThinking || isRegenerating;
    const isFullPanelLoading = !hasSuggestions && isThinking;
    (0, $2gVZP.useSuggestionsPanelOpenAnalytics)({
        entryPoint: entryPoint,
        fireAnalyticsEvent: fullPageEditorPresetAPI?.analytics?.actions.fireAnalyticsEvent,
        isFullPanelLoading: isFullPanelLoading,
        suggestions: suggestions
    });
    (0, $2gVZP.useEmptyStateExposedAnalytics)({
        emptyStateType: $53ea9a41ca4eb886$var$emptyStateAnalyticsTypes[emptyVariant],
        enabled: !isFullPanelLoading && !hasPendingSuggestions && !isEmptyStateTransitionPending,
        fireAnalyticsEvent: fullPageEditorPresetAPI?.analytics?.actions.fireAnalyticsEvent
    });
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "suggestions-panel-list-container",
        className: (0, $hekY6.default)([
            $53ea9a41ca4eb886$var$styles.panelContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text.subtle"
    }, formatMessage($53ea9a41ca4eb886$var$i18n.errorMessage)));
    if (isInitialising) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $anzFm.SuggestionsInitialLoading), null);
    if (!visibleSuggestions?.length) {
        if (isFullPanelLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hkoM6.SuggestionsLoadingState), {
            api: fullPageEditorPresetAPI,
            agentName: reviewingAgentName,
            isAgentLoading: isAgentLoading,
            startedAt: thinkingStartedAt,
            rotationStartedAt: loadingRotationStartedAt,
            progressTarget: thinkingProgressTarget
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEpsr.SuggestionsEmptyState), {
            api: fullPageEditorPresetAPI,
            onReview: isPublishedMode ? published.startReviewInEditMode : undefined,
            variant: isPublishedMode || hasPendingSuggestions ? 'initial' : emptyVariant
        });
    }
    const suggestionItemActions = isPublishedMode ? {
        onView: published.isHeadingToEditMode ? undefined : published.openInEditMode,
        isActionDisabled: published.isHeadingToEditMode
    } : {
        fireAnalyticsEvent: fullPageEditorPresetAPI?.analytics?.actions.fireAnalyticsEvent,
        onAccept: handleAccept,
        onDiscard: handleDiscard,
        onDismiss: handleDismiss,
        onGoodSuggestion: handleGoodSuggestion,
        onBadSuggestion: handleBadSuggestion,
        onToggleDeletedDiffs: handleToggleDeletedDiffs
    };
    const isStackShown = (0, $6mKj3.isExperimentEnabled)('platform_editor_ai_content_suggested_edits_labs');
    const suggestionItems = visibleSuggestions.map((suggestion_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $H1gk2.SuggestionItem), {
            key: suggestion_1.id,
            suggestion: suggestion_1,
            isStackAnimating: isStackShown ? isStackAnimating : undefined,
            isSelected: selectedSuggestionId === suggestion_1.id,
            isRegenerating: regeneratingSuggestionIds?.has(suggestion_1.id) ?? false,
            onSelect: handleSelect,
            ...suggestionItemActions
        }));
    const isEditModeBannerShown = isPublishedMode && !published.isHeadingToEditMode; // Suggestions exist: keep the list visible; show the inline bar at the bottom
    // while regenerating.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // Clearance for the footer scrim lives on the scroll container in
    , {
        // `SuggestionsPanelLayout`, so every panel state gets it.
        "data-testid": "suggestions-panel-list-container",
        className: (0, $hekY6.default)([
            $53ea9a41ca4eb886$var$styles.panelContainer
        ])
    }, isEditModeBannerShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ifwMO.SuggestionsEditModeBanner), {
        onEdit: published.openInEditMode
    }), isStackShown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Kj0o.SuggestionsStack), {
        isAnimating: isStackAnimating,
        onAnimationComplete: handleAnimationComplete
    }, suggestionItems) : suggestionItems, showInlineLoadingBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ap8M1.SuggestionsInlineLoadingBar), {
        api: fullPageEditorPresetAPI,
        startedAt: loadingRotationStartedAt,
        agent: reviewingAgent,
        isAgentLoading: isAgentLoading
    }));
};
module.exports["SuggestionsPanel"] = $53ea9a41ca4eb886$export$108b4a99093fdc66;

});

parcelRegister("2gVZP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aGFDz = parcelRequire("aGFDz");


var $krYZG = parcelRequire("krYZG");

const $74b707272652ad53$export$feb70f72d3f02470 = 'suggestionsPanel';
const $74b707272652ad53$export$f0cb1896f2ffc5ff = (0, $aGFDz.AiSuggestionsEntryPointValue).SUGGESTIONS_PANEL_EMPTY_STATE;
const $74b707272652ad53$var$getTimeSinceGenerationAttribute = (suggestion)=>{
    const createdAt = Date.parse(suggestion.createdAt);
    return Number.isFinite(createdAt) ? {
        timeSinceGenerationMs: Math.max(0, Date.now() - createdAt)
    } : {};
};
const $74b707272652ad53$var$getSuggestionRemixAttributes = (suggestion)=>{
    if (suggestion.actionKind !== 'SUGGESTED_REMIX') return {};
    return {
        ...suggestion.action?.launchOptions?.dynamicUiType ? {
            remixType: suggestion.action.launchOptions.dynamicUiType
        } : {},
        ...suggestion.action?.launchOptions?.dynamicUiSubtype ? {
            remixSubtype: suggestion.action.launchOptions.dynamicUiSubtype
        } : {}
    };
};
const $74b707272652ad53$var$getAffectedBlocks = (suggestion)=>{
    const localIds = [
        ...suggestion.action?.localIds ?? [],
        ...suggestion.toolCalls?.flatMap((toolCall)=>toolCall.name === 'removeNodes' ? toolCall.arguments.localIds ?? [] : toolCall.arguments.localId ? [
                toolCall.arguments.localId
            ] : []) ?? []
    ];
    return new Set(localIds).size;
};
const $74b707272652ad53$export$78a8938cdd76433e = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { emptyStateType: emptyStateType, enabled: enabled, fireAnalyticsEvent: fireAnalyticsEvent } = t0;
    const lastExposedEmptyStateRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== emptyStateType || $[1] !== enabled || $[2] !== fireAnalyticsEvent) {
        t1 = ()=>{
            if (!enabled) {
                lastExposedEmptyStateRef.current = null;
                return;
            }
            if (!fireAnalyticsEvent || lastExposedEmptyStateRef.current === emptyStateType) return;
            fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).EMPTY_STATE_EXPOSED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    emptyStateType: emptyStateType
                }
            });
            lastExposedEmptyStateRef.current = emptyStateType;
        };
        t2 = [
            emptyStateType,
            enabled,
            fireAnalyticsEvent
        ];
        $[0] = emptyStateType;
        $[1] = enabled;
        $[2] = fireAnalyticsEvent;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
};
const $74b707272652ad53$export$e36cd52aaccf334e = (fireAnalyticsEvent)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== fireAnalyticsEvent) {
        t0 = (suggestion)=>{
            fireAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).REASONING_VIEWED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    actionKind: suggestion.actionKind ?? "SUGGESTED_EDIT",
                    affectedBlocks: $74b707272652ad53$var$getAffectedBlocks(suggestion),
                    agentId: suggestion.createdByAgent?.accountId,
                    hasSources: Boolean(suggestion.sources?.length),
                    interactionPoint: "sidebar",
                    reasoningCharacterCount: suggestion.reasoning?.length ?? 0,
                    ...$74b707272652ad53$var$getTimeSinceGenerationAttribute(suggestion),
                    ...$74b707272652ad53$var$getSuggestionRemixAttributes(suggestion),
                    suggestionId: suggestion.id,
                    suggestionType: suggestion.type
                }
            });
        };
        $[0] = fireAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $74b707272652ad53$export$877ef7c4e1fdf468 = (fireAnalyticsEvent)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== fireAnalyticsEvent) {
        t0 = ()=>{
            fireAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).CANCELLED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    interactionPoint: "sidebar"
                }
            });
        };
        $[0] = fireAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $74b707272652ad53$export$723fb246d0d2b9b9 = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { entryPoint: entryPoint, fireAnalyticsEvent: fireAnalyticsEvent, isFullPanelLoading: isFullPanelLoading, suggestions: suggestions } = t0;
    const hasFiredRef = (0, $cozmU.useRef)(false);
    let t1;
    let t2;
    if ($[0] !== entryPoint || $[1] !== fireAnalyticsEvent || $[2] !== isFullPanelLoading || $[3] !== suggestions) {
        t1 = ()=>{
            if (hasFiredRef.current || isFullPanelLoading || !fireAnalyticsEvent) return;
            const suggestionDetails = (suggestions ?? []).map($74b707272652ad53$var$_temp);
            fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).RIGHT_RAIL_VIEWED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    entryPoint: entryPoint,
                    numberOfSuggestions: suggestionDetails.length,
                    suggestionDetails: suggestionDetails
                }
            });
            hasFiredRef.current = true;
        };
        t2 = [
            entryPoint,
            fireAnalyticsEvent,
            isFullPanelLoading,
            suggestions
        ];
        $[0] = entryPoint;
        $[1] = fireAnalyticsEvent;
        $[2] = isFullPanelLoading;
        $[3] = suggestions;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
};
function $74b707272652ad53$var$_temp(suggestion) {
    return {
        suggestionType: suggestion.type,
        actionKind: suggestion.actionKind ?? "SUGGESTED_EDIT",
        affectedBlocks: $74b707272652ad53$var$getAffectedBlocks(suggestion),
        ...$74b707272652ad53$var$getTimeSinceGenerationAttribute(suggestion),
        ...$74b707272652ad53$var$getSuggestionRemixAttributes(suggestion)
    };
}
module.exports["SUGGESTIONS_PANEL_ANALYTICS_SOURCE"] = $74b707272652ad53$export$feb70f72d3f02470;
module.exports["SUGGESTIONS_PANEL_EMPTY_STATE_ENTRY_POINT"] = $74b707272652ad53$export$f0cb1896f2ffc5ff;
module.exports["useEmptyStateExposedAnalytics"] = $74b707272652ad53$export$78a8938cdd76433e;
module.exports["useReasoningViewedAnalytics"] = $74b707272652ad53$export$e36cd52aaccf334e;
module.exports["useCancelledAnalytics"] = $74b707272652ad53$export$877ef7c4e1fdf468;
module.exports["useSuggestionsPanelOpenAnalytics"] = $74b707272652ad53$export$723fb246d0d2b9b9;

});

parcelRegister("lXxb6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iXzFq = parcelRequire("iXzFq");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $39rFu = parcelRequire("39rFu");


var $ep3mz = parcelRequire("ep3mz");


var $de2j9 = parcelRequire("de2j9");


var $bQm3c = parcelRequire("bQm3c");


var $iISzu = parcelRequire("iISzu");


var $kJr0V = parcelRequire("kJr0V");

const $c6d96ea7d89228c4$var$useOpenSuggestionInEditMode = (contentId)=>{
    const $ = (0, $bDgLe.c)(6);
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const [t0] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = t0 === undefined ? "" : t0;
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let t1;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== isEditorPage || $[3] !== loadEditor || $[4] !== spaceKey) {
        t1 = (suggestionId)=>{
            if (!contentId || isEditorPage) return;
            if (suggestionId) (0, $iISzu.selectPublishedSuggestion)(suggestionId);
            loadEditor({
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: contentType,
                redirectUrl: (0, $iXzFq.getUrlForContentType)({
                    contentType: contentType,
                    spaceKey: spaceKey,
                    contentId: contentId,
                    redirectToEditor: true
                })
            });
        };
        $[0] = contentId;
        $[1] = contentType;
        $[2] = isEditorPage;
        $[3] = loadEditor;
        $[4] = spaceKey;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
const $c6d96ea7d89228c4$export$72e25f24014e199e = (isPublishedMode)=>{
    const $ = (0, $bDgLe.c)(15);
    const { contentId: contentId } = (0, $kJr0V.usePublishedSuggestionsState)();
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    let t1;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== isEditorPage || $[3] !== isPublishedMode || $[4] !== pageContentId) {
        t0 = ()=>{
            if (isPublishedMode && !isEditorPage && pageContentId && pageContentId !== contentId && (0, $6mKj3.expValEquals)("platform_editor_ai_content_suggested_edits", "isEnabled", true) && (0, $9wGTI.fg)("confluence_suggestions_panel_view_mode")) (0, $iISzu.startPublishedSuggestions)(pageContentId, cloudId);
        };
        t1 = [
            cloudId,
            contentId,
            isEditorPage,
            isPublishedMode,
            pageContentId
        ];
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = isEditorPage;
        $[3] = isPublishedMode;
        $[4] = pageContentId;
        $[5] = t0;
        $[6] = t1;
    } else {
        t0 = $[5];
        t1 = $[6];
    }
    (0, $cozmU.useEffect)(t0, t1);
    const openSuggestionInEditMode = $c6d96ea7d89228c4$var$useOpenSuggestionInEditMode(contentId);
    const [isOpeningEditMode, setIsOpeningEditMode] = (0, $cozmU.useState)(false);
    let t2;
    if ($[7] !== openSuggestionInEditMode) {
        t2 = (suggestionId)=>{
            setIsOpeningEditMode(true);
            openSuggestionInEditMode(suggestionId);
        };
        $[7] = openSuggestionInEditMode;
        $[8] = t2;
    } else t2 = $[8];
    const openInEditMode = t2;
    let t3;
    if ($[9] !== openInEditMode) {
        t3 = ()=>{
            (0, $iISzu.requestPublishedReviewInEditMode)();
            openInEditMode();
        };
        $[9] = openInEditMode;
        $[10] = t3;
    } else t3 = $[10];
    const startReviewInEditMode = t3;
    const t4 = isOpeningEditMode || isEditorPage;
    let t5;
    if ($[11] !== openInEditMode || $[12] !== startReviewInEditMode || $[13] !== t4) {
        t5 = {
            isHeadingToEditMode: t4,
            openInEditMode: openInEditMode,
            startReviewInEditMode: startReviewInEditMode
        };
        $[11] = openInEditMode;
        $[12] = startReviewInEditMode;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
};
module.exports["usePublishedSuggestionsPanel"] = $c6d96ea7d89228c4$export$72e25f24014e199e;

});

parcelRegister("73rWB", function(module, exports) {
var $4137f5e0fc50aed8$export$93967f9a85fea266 = /*#__PURE__*/ function(SuggestionFilterValues) {
    SuggestionFilterValues["ALL"] = "ALL";
    SuggestionFilterValues["CREATED_BY_ME"] = "CREATED_BY_ME";
    return SuggestionFilterValues;
}({});
var $4137f5e0fc50aed8$export$9178e2e514c30a44 = /*#__PURE__*/ function(SuggestionSortValues) {
    /** Document order — the order the plugin already keeps `orderedSuggestionIds` in. */ SuggestionSortValues["TOP_TO_BOTTOM"] = "TOP_TO_BOTTOM";
    /** Most recently generated suggestion first. */ SuggestionSortValues["NEW_TO_OLD"] = "NEW_TO_OLD";
    return SuggestionSortValues;
}({});
const $4137f5e0fc50aed8$var$getCreatedAtTime = (createdAt)=>{
    const time = createdAt ? Date.parse(createdAt) : Number.NaN;
    // Suggestions without a usable timestamp sort last under "New → Old".
    return Number.isNaN(time) ? 0 : time;
};
const $4137f5e0fc50aed8$export$856448e126eaf568 = (suggestions, currentFilter, currentUserId)=>{
    if (currentFilter !== "CREATED_BY_ME") return [
        ...suggestions
    ];
    // Without an account id nothing can be attributed to the current user, so nothing matches.
    return suggestions.filter((suggestion)=>!!currentUserId && suggestion.createdByUser?.accountId === currentUserId);
};
const $4137f5e0fc50aed8$export$27b75277c6b7e8e0 = (suggestions, currentSort)=>{
    if (currentSort !== "NEW_TO_OLD") // Already in document order.
    return [
        ...suggestions
    ];
    // Decorate with the document index so suggestions sharing a timestamp keep document order.
    const decorated = suggestions.map((suggestion, index)=>({
            createdAtTime: $4137f5e0fc50aed8$var$getCreatedAtTime(suggestion.createdAt),
            index: index,
            suggestion: suggestion
        }));
    decorated.sort((a, b)=>{
        const byCreatedAt = b.createdAtTime - a.createdAtTime;
        return byCreatedAt !== 0 ? byCreatedAt : a.index - b.index;
    });
    return decorated.map(({ suggestion: suggestion })=>suggestion);
};
const $4137f5e0fc50aed8$export$d5ab9ea527bcd525 = (suggestions, { currentFilter: currentFilter, currentSort: currentSort, currentUserId: currentUserId })=>{
    if (!suggestions) return undefined;
    return $4137f5e0fc50aed8$export$27b75277c6b7e8e0($4137f5e0fc50aed8$export$856448e126eaf568(suggestions, currentFilter, currentUserId), currentSort);
};
module.exports["SuggestionFilterValues"] = $4137f5e0fc50aed8$export$93967f9a85fea266;
module.exports["SuggestionSortValues"] = $4137f5e0fc50aed8$export$9178e2e514c30a44;
module.exports["filterSuggestions"] = $4137f5e0fc50aed8$export$856448e126eaf568;
module.exports["getVisibleSuggestions"] = $4137f5e0fc50aed8$export$d5ab9ea527bcd525;

});

parcelRegister("71PZp", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $73rWB = parcelRequire("73rWB");

/**
 * The filter menu lives in the object sidebar header while the list lives in the panel body, so the
 * two render in separate trees. A module level store is what lets them share the selection.
 */ const $b08257a47d9e1e10$var$initialState = {
    currentFilter: (0, $73rWB.SuggestionFilterValues).ALL,
    currentSort: (0, $73rWB.SuggestionSortValues).TOP_TO_BOTTOM
};
const $b08257a47d9e1e10$var$actions = {
    setCurrentFilter: (currentFilter)=>({ setState: setState })=>{
            setState({
                currentFilter: currentFilter
            });
        },
    setCurrentSort: (currentSort)=>({ setState: setState })=>{
            setState({
                currentSort: currentSort
            });
        },
    resetFilters: ()=>({ setState: setState })=>{
            setState($b08257a47d9e1e10$var$initialState);
        }
};
const $b08257a47d9e1e10$export$266acf20f4be7303 = (0, $8s9DV.createStore)({
    initialState: $b08257a47d9e1e10$var$initialState,
    actions: $b08257a47d9e1e10$var$actions,
    name: 'SuggestionsPanelFiltersStore'
});
const $b08257a47d9e1e10$export$153c155c6c0c651 = (0, $kBr4q.createHook)($b08257a47d9e1e10$export$266acf20f4be7303);
const $b08257a47d9e1e10$export$ae80fe2cbdda181f = (0, $kBr4q.createActionsHook)($b08257a47d9e1e10$export$266acf20f4be7303);
module.exports["useSuggestionsPanelFilters"] = $b08257a47d9e1e10$export$153c155c6c0c651;

});

parcelRegister("ifwMO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $gC2EJ = parcelRequire("gC2EJ");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");

const $9ae7752feaf311af$var$i18n = (0, $kSwu1.defineMessages)({
    editModeBannerMessage: {
        id: "suggestions-panel.published.edit-mode-banner.message",
        defaultMessage: "View suggestions in edit mode"
    },
    editModeBannerButton: {
        id: "suggestions-panel.published.edit-mode-banner.button",
        defaultMessage: "Edit"
    }
});
const $9ae7752feaf311af$var$styles = {
    banner: "_0bjKvD8fU6 _4c065U2ADO _0KLXrugNg3 _0LQT5E5zaO _03SyCP2ADO"
};
const $9ae7752feaf311af$export$9aae84db1731b4df = (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { onEdit: onEdit } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $9ae7752feaf311af$var$styles.banner
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage($9ae7752feaf311af$var$i18n.editModeBannerMessage);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p",
            weight: "semibold"
        }, t2);
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== onEdit) {
        t4 = ()=>onEdit();
        $[5] = onEdit;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== formatMessage) {
        t5 = formatMessage($9ae7752feaf311af$var$i18n.editModeBannerButton);
        $[7] = formatMessage;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t4 || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
            onClick: t4
        }, t5);
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t3 || $[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "published-suggestions-edit-mode-banner",
            className: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between"
        }, t3, t6));
        $[12] = t3;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
};
module.exports["SuggestionsEditModeBanner"] = $9ae7752feaf311af$export$9aae84db1731b4df;

});

parcelRegister("fEpsr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $gVCFw = parcelRequire("gVCFw");


var $I7hWB = parcelRequire("I7hWB");


var $cJ0FD = parcelRequire("cJ0FD");


var $4u3xL = parcelRequire("4u3xL");


var $4aRua = parcelRequire("4aRua");


var $2gVZP = parcelRequire("2gVZP");


var $djfAu = parcelRequire("djfAu");


var $3eyLF = parcelRequire("3eyLF");


var $dZBvH = parcelRequire("dZBvH");


var $d276e = parcelRequire("d276e");


var $hDutP = parcelRequire("hDutP");


var $1VPsJ = parcelRequire("1VPsJ");

const $90da8afb920d8a75$var$styles = {
    container: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _4kiQYAN91d _0Of8r2NHnM _1wydGWNHnM _2Zuz6QNHnM _1ZnuxbNHnM",
    outcome: "_2mHwu8kG2W",
    content: "_2mHwu8kG2W _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02N91d",
    text: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d _2fwxA5DIqT _3zvHkHdC7N"
};
const $90da8afb920d8a75$var$i18n = (0, $kSwu1.defineMessages)({
    initialHeading: {
        id: "suggestions-panel.empty-state.initial.heading",
        defaultMessage: "Better work, in less time"
    },
    initialDescription: {
        id: "suggestions-panel.empty-state.initial.description",
        defaultMessage: "Get suggestions to improve your writing, structure, and accuracy."
    },
    noResultsHeading: {
        id: "suggestions-panel.empty-state.no-results.heading",
        defaultMessage: "No suggestions found"
    },
    noResultsDescription: {
        id: "suggestions-panel.empty-state.no-results.content-reviewer-description",
        defaultMessage: "Content Reviewer checked the writing, structure, and accuracy."
    },
    resolvedHeading: {
        id: "suggestions-panel.empty-state.resolved.heading",
        defaultMessage: "All suggestions resolved"
    },
    resolvedDescription: {
        id: "suggestions-panel.empty-state.resolved.description",
        defaultMessage: "Review again when you\u2019ve made edits to get new suggestions."
    },
    reviewAgain: {
        id: "suggestions-panel.empty-state.review-again",
        defaultMessage: "Review again"
    }
});
const $90da8afb920d8a75$var$presentations = {
    initial: {
        heading: $90da8afb920d8a75$var$i18n.initialHeading,
        description: $90da8afb920d8a75$var$i18n.initialDescription,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($3eyLF))),
        darkImage: (0, (/*@__PURE__*/$parcel$interopDefault($3eyLF))),
        width: 109.5
    },
    noSuggestionsResult: {
        heading: $90da8afb920d8a75$var$i18n.noResultsHeading,
        description: $90da8afb920d8a75$var$i18n.noResultsDescription,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($1VPsJ))),
        darkImage: (0, (/*@__PURE__*/$parcel$interopDefault($dZBvH))),
        width: 72
    },
    allResolved: {
        heading: $90da8afb920d8a75$var$i18n.resolvedHeading,
        description: $90da8afb920d8a75$var$i18n.resolvedDescription,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($hDutP))),
        darkImage: (0, (/*@__PURE__*/$parcel$interopDefault($d276e))),
        width: 72
    }
};
const $90da8afb920d8a75$export$11bc3fbd4b223a9b = (t0)=>{
    const $ = (0, $bDgLe.c)(39);
    const { api: api, onReview: onReview, variant: t1 } = t0;
    const variant = t1 === undefined ? "initial" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isOffline = (0, $djfAu.useIsOffline)(api);
    let t2;
    if ($[0] !== api?.aiSuggestions?.actions || $[1] !== isOffline || $[2] !== onReview) {
        t2 = ()=>{
            if (isOffline) return;
            if (onReview) {
                onReview();
                return;
            }
            api?.aiSuggestions?.actions?.setThinkingState("thinking", {
                entryPoint: (0, $2gVZP.SUGGESTIONS_PANEL_EMPTY_STATE_ENTRY_POINT)
            });
        };
        $[0] = api?.aiSuggestions?.actions;
        $[1] = isOffline;
        $[2] = onReview;
        $[3] = t2;
    } else t2 = $[3];
    const handleClick = t2;
    const presentation = $90da8afb920d8a75$var$presentations[variant];
    const t3 = variant !== "initial" && $90da8afb920d8a75$var$styles.outcome;
    let t4;
    if ($[4] !== t3) {
        t4 = (0, $hekY6.default)([
            $90da8afb920d8a75$var$styles.container,
            t3
        ]);
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== presentation.darkImage || $[7] !== presentation.image || $[8] !== presentation.width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: presentation.image,
            srcDark: presentation.darkImage,
            width: presentation.width,
            alt: ""
        });
        $[6] = presentation.darkImage;
        $[7] = presentation.image;
        $[8] = presentation.width;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $90da8afb920d8a75$var$styles.content
        ]);
        t7 = (0, $hekY6.default)([
            $90da8afb920d8a75$var$styles.text
        ]);
        $[10] = t6;
        $[11] = t7;
    } else {
        t6 = $[10];
        t7 = $[11];
    }
    let t8;
    if ($[12] !== formatMessage || $[13] !== presentation.heading) {
        t8 = formatMessage(presentation.heading);
        $[12] = formatMessage;
        $[13] = presentation.heading;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "small"
        }, t8);
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== formatMessage || $[18] !== presentation.description) {
        t10 = formatMessage(presentation.description);
        $[17] = formatMessage;
        $[18] = presentation.description;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p",
            size: "medium",
            align: "center"
        }, t10);
        $[20] = t10;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== t11 || $[23] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t7
        }, t9, t11);
        $[22] = t11;
        $[23] = t9;
        $[24] = t12;
    } else t12 = $[24];
    const t13 = variant === "noSuggestionsResult" ? $90da8afb920d8a75$var$i18n.reviewAgain : (0, $gVCFw.aiSuggestionsMessages).suggestEditsButtonLabel;
    let t14;
    if ($[25] !== formatMessage || $[26] !== t13) {
        t14 = formatMessage(t13);
        $[25] = formatMessage;
        $[26] = t13;
        $[27] = t14;
    } else t14 = $[27];
    let t15;
    if ($[28] !== handleClick || $[29] !== isOffline || $[30] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($4u3xL))),
            onClick: handleClick,
            isDisabled: isOffline
        }, t14);
        $[28] = handleClick;
        $[29] = isOffline;
        $[30] = t14;
        $[31] = t15;
    } else t15 = $[31];
    let t16;
    if ($[32] !== t12 || $[33] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t6
        }, t12, t15);
        $[32] = t12;
        $[33] = t15;
        $[34] = t16;
    } else t16 = $[34];
    let t17;
    if ($[35] !== t16 || $[36] !== t4 || $[37] !== t5) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t4
        }, t5, t16);
        $[35] = t16;
        $[36] = t4;
        $[37] = t5;
        $[38] = t17;
    } else t17 = $[38];
    return t17;
};
module.exports["SuggestionsEmptyState"] = $90da8afb920d8a75$export$11bc3fbd4b223a9b;

});

parcelRegister("gVCFw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $41c05f11e4e9fb00$export$e4f30354a76c156b = (0, $kSwu1.defineMessages)({
    suggestEditsButtonLabel: {
        id: "fabric.editor.ai.suggestions.suggestEditsButtonLabel",
        defaultMessage: "Review"
    },
    suggestEditsButtonTooltip: {
        id: "fabric.editor.ai.suggestions.suggestEditsButtonTooltip",
        defaultMessage: "Get AI suggestions to improve content"
    },
    suggestEditsPromptPrefix: {
        id: "fabric.editor.ai.suggestions.suggestEditsPromptPrefix.non-final",
        defaultMessage: "Review my content with "
    },
    contentReviewAgentPrompt: {
        id: "fabric.editor.ai.suggestions.contentReviewAgentPrompt.non-final",
        defaultMessage: "Review my content and suggest improvements"
    },
    suggestionsToolbarButtonLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.label.non-final",
        defaultMessage: "Suggestions"
    },
    suggestionsToolbarButtonLoadingLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.loadingLabel.non-final",
        defaultMessage: "Loading"
    },
    suggestionsToolbarButtonReadyLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.readyLabel.non-final",
        defaultMessage: "View"
    },
    suggestionsToolbarButtonErrorLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.errorLabel.non-final",
        defaultMessage: "Retry"
    },
    previewLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.previewLabel.non-final",
        defaultMessage: "Preview"
    },
    viewLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.viewLabel.non-final",
        defaultMessage: "View"
    },
    titleLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.titleLabel.non-final",
        defaultMessage: "Title"
    },
    reviewNote: {
        id: "fabric.editor.ai.suggestions.stagingArea.reviewNote.non-final",
        defaultMessage: "Review \u2022 Only visible to you"
    },
    applyChangesButtonLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.applyChangesButtonLabel.non-final",
        defaultMessage: "Apply changes"
    },
    fetchSuggestionsButtonLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.fetchSuggestionsButtonLabel.non-final",
        defaultMessage: "Fetch suggestions"
    },
    fetchSuggestionsButtonLoadingLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.fetchSuggestionsButtonLoadingLabel.non-final",
        defaultMessage: "Loading\u2026"
    },
    followUpCardTitle: {
        id: "fabric.editor.ai.suggestions.followUpCard.title.non-final",
        defaultMessage: "Review the rest?"
    },
    followUpCardDescription: {
        id: "fabric.editor.ai.suggestions.followUpCard.description.non-final",
        defaultMessage: "Generate suggestions to improve the rest of your content."
    },
    followUpCardReviewButtonLabel: {
        id: "fabric.editor.ai.suggestions.followUpCard.reviewButtonLabel.non-final",
        defaultMessage: "Review"
    },
    iconButtonSuggestionsCountLabel: {
        id: "fabric.editor.ai.suggestions.iconButton.suggestionsCountLabel.non-final",
        defaultMessage: "{count} suggestions"
    },
    labsLozengeLabel: {
        id: "fabric.editor.ai.suggestions.labsLozengeLabel.non-final",
        defaultMessage: "Labs"
    },
    originalViewLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.originalViewLabel.non-final",
        defaultMessage: "Original \u2022 View only"
    },
    suggestedLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.suggestedLabel.non-final",
        defaultMessage: "Suggested"
    },
    suggestionsLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.suggestionsLabel.non-final",
        defaultMessage: "Suggestions"
    },
    cardCloseButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.closeSuggestionButtonLabel.non-final",
        defaultMessage: "Close suggestion"
    },
    cardShowSidebarButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.showSuggestionsButtonLabel.non-final",
        defaultMessage: "Show suggestions"
    },
    cardPreviousSuggestionButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.previousSuggestionButtonLabel.non-final",
        defaultMessage: "Previous suggestion"
    },
    cardNextSuggestionButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.nextSuggestionButtonLabel.non-final",
        defaultMessage: "Next suggestion"
    },
    cardExpandButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.expandButtonLabel.non-final",
        defaultMessage: "Expand"
    },
    cardCollapseButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.collapseButtonLabel.non-final",
        defaultMessage: "Collapse"
    },
    cardRovoTitle: {
        id: "fabric.editor.ai.suggestions.card.rovoTitle.non-final",
        defaultMessage: "Rovo"
    },
    cardRovoAuthorLabel: {
        id: "editor-common.ai-messages.ai-suggestions.cardRovoAuthorLabel",
        defaultMessage: "Rovo"
    },
    cardAuthorsTooltipLabel: {
        id: "fabric.editor.ai.suggestions.card.authorsTooltipLabel.non-final",
        defaultMessage: "{agentName} with {userName}"
    },
    cardPrivateLabel: {
        id: "fabric.editor.ai.suggestions.card.privateLabel.non-final",
        defaultMessage: "Private"
    },
    cardPrivateTooltipLabelShort: {
        id: "fabric.editor.ai.suggestions.card.privateTooltipLabelShort.non-final",
        defaultMessage: "Visible only to you"
    },
    cardRestrictedLabel: {
        id: "fabric.editor.ai.suggestions.card.restrictedLabel.non-final",
        defaultMessage: "Restricted"
    },
    cardRestrictedTooltipLabel: {
        id: "fabric.editor.ai.suggestions.card.restrictedTooltip.non-final",
        defaultMessage: "Only editors with access to the source can see this suggestion"
    },
    cardDetailsButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.detailsButtonLabel.non-final",
        defaultMessage: "Details"
    },
    cardSourceAppsLabel: {
        id: "fabric.editor.ai.suggestions.card.sourceAppsLabel.non-final",
        defaultMessage: "Source apps"
    },
    cardSourceAppsTooltip: {
        id: "fabric.editor.ai.suggestions.card.sourceAppsTooltip.non-final",
        defaultMessage: "Sources from {apps}"
    },
    cardSourcesButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.sourcesButtonLabel.non-final",
        defaultMessage: "Sources"
    },
    cardSourcesHideButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.hideReasoningButtonLabel.non-final",
        defaultMessage: "Hide reasoning"
    },
    cardSourcesShowButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.showReasoningButtonLabel.non-final",
        defaultMessage: "Show reasoning"
    },
    cardAcceptButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.acceptButtonLabel.non-final",
        defaultMessage: "Accept"
    },
    cardStaleBannerLabel: {
        id: "fabric.editor.ai.suggestions.card.staleBannerLabel.non-final",
        defaultMessage: "This suggestion is outdated."
    },
    cardRegeneratingBannerLabel: {
        id: "fabric.editor.ai.suggestions.card.regeneratingBannerLabel.non-final",
        defaultMessage: "Updating suggestion..."
    },
    cardUpdatedBannerLabel: {
        id: "fabric.editor.ai.suggestions.card.updatedBannerLabel.non-final",
        defaultMessage: "Suggestion updated."
    },
    cardDiscardButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.discardButtonLabel.non-final",
        defaultMessage: "Discard"
    },
    cardDisclaimerText: {
        id: "fabric.editor.ai.suggestions.card.disclaimerText.non-final",
        defaultMessage: "Uses AI. Verify results."
    },
    cardDismissButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.dismissButtonLabel.non-final",
        defaultMessage: "Dismiss"
    },
    cardMoreOptionsButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.moreActionsButtonLabel.non-final",
        defaultMessage: "More actions"
    },
    cardGoodSuggestionLabel: {
        id: "fabric.editor.ai.suggestions.card.goodSuggestionLabel.non-final",
        defaultMessage: "Good suggestion"
    },
    cardBadSuggestionLabel: {
        id: "fabric.editor.ai.suggestions.card.badSuggestionLabel.non-final",
        defaultMessage: "Bad suggestion"
    },
    cardOnlyShowSuggestionOptionLabel: {
        id: "fabric.editor.ai.suggestions.card.onlyShowSuggestionOptionLabel.non-final",
        defaultMessage: "Only show suggestion"
    },
    cardCompareWithOriginalOptionLabel: {
        id: "fabric.editor.ai.suggestions.card.compareWithOriginalOptionLabel.non-final",
        defaultMessage: "Compare with original"
    },
    cardHideDeletedDiffsLabel: {
        id: "fabric.editor.ai.suggestions.card.hideDeletedDiffsLabel.non-final",
        defaultMessage: "Hide comparison"
    },
    cardShowDeletedDiffsLabel: {
        id: "fabric.editor.ai.suggestions.card.showDeletedDiffsLabel.non-final",
        defaultMessage: "Show comparison"
    },
    cardScrollBackToSuggestionLabel: {
        id: "fabric.editor.ai.suggestions.card.scrollBackToSuggestionLabel.non-final",
        defaultMessage: "Back to suggestion"
    },
    thinkingEscHint: {
        id: "fabric.editor.ai.suggestions.thinking.escHint.non-final",
        defaultMessage: "Esc"
    },
    thinkingStopLabel: {
        id: "fabric.editor.ai.suggestions.thinking.stopLabel.non-final",
        defaultMessage: "Stop"
    },
    thinkingReviewingContent: {
        id: "fabric.editor.ai.suggestions.thinking.rovoReviewingPage.non-final",
        defaultMessage: "Rovo is reviewing your page"
    },
    thinkingPreparingAgent: {
        id: "fabric.editor.ai.suggestions.thinking.preparingAgent.non-final",
        defaultMessage: "Preparing agent"
    },
    thinkingReviewingContentWithAgent: {
        id: "fabric.editor.ai.suggestions.thinking.agentAnalyzing.non-final",
        defaultMessage: "{agentName} is analyzing"
    },
    thinkingMayTakeAFewMinutes: {
        id: "fabric.editor.ai.suggestions.thinking.mayTakeAFewMinutes.non-final",
        defaultMessage: "This may take a few minutes"
    },
    thinkingReviewingConsistency: {
        id: "fabric.editor.ai.suggestions.thinking.reviewingConsistency.non-final",
        defaultMessage: "Reviewing consistency"
    },
    thinkingCheckingWritingClarity: {
        id: "fabric.editor.ai.suggestions.thinking.checkingWritingClarity.non-final",
        defaultMessage: "Checking writing clarity"
    },
    thinkingGeneratingAiSuggestions: {
        id: "fabric.editor.ai.suggestions.thinking.generatingAiSuggestions.non-final",
        defaultMessage: "Generating AI suggestions"
    },
    thinkingRefiningAiSuggestions: {
        id: "fabric.editor.ai.suggestions.thinking.refiningAiSuggestions.non-final",
        defaultMessage: "Refining AI suggestions"
    },
    thinkingPrioritizingAiSuggestions: {
        id: "fabric.editor.ai.suggestions.thinking.prioritizingAiSuggestions.non-final",
        defaultMessage: "Prioritizing AI suggestions"
    },
    // Superseded in the rotating list by the messages above, which match the product's
    // suggestions panel. Kept defined so removing them from `aiSuggestionsMessages` isn't a
    // breaking change to this shared map; safe to delete once nothing can reach for them.
    thinkingAnalyzingStructure: {
        id: "fabric.editor.ai.suggestions.thinking.analyzingStructure.non-final",
        defaultMessage: "Analyzing structure"
    },
    thinkingCheckingRelatedSources: {
        id: "fabric.editor.ai.suggestions.thinking.checkingRelatedSources.non-final",
        defaultMessage: "Checking related sources"
    },
    thinkingGatheringContext: {
        id: "fabric.editor.ai.suggestions.thinking.gatheringContext.non-final",
        defaultMessage: "Gathering context"
    },
    thinkingIdentifyingImprovements: {
        id: "fabric.editor.ai.suggestions.thinking.identifyingImprovements.non-final",
        defaultMessage: "Identifying improvements"
    },
    thinkingEvaluatingOptions: {
        id: "fabric.editor.ai.suggestions.thinking.evaluatingOptions.non-final",
        defaultMessage: "Evaluating options"
    },
    thinkingCheckingConsistency: {
        id: "fabric.editor.ai.suggestions.thinking.checkingConsistency.non-final",
        defaultMessage: "Checking consistency"
    },
    thinkingPreparingSuggestions: {
        id: "fabric.editor.ai.suggestions.thinking.preparingSuggestions.non-final",
        defaultMessage: "Preparing suggestions"
    },
    thinkingRefiningSuggestions: {
        id: "fabric.editor.ai.suggestions.thinking.refiningSuggestions.non-final",
        defaultMessage: "Refining suggestions"
    },
    thinkingFinalizingSuggestionsForReview: {
        id: "fabric.editor.ai.suggestions.thinking.finalizingSuggestionsForReview.non-final",
        defaultMessage: "Finalizing suggestions for review"
    },
    thinkingCompleteSuggestionCount: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.suggestionCount.non-final",
        defaultMessage: "{count, plural, one {# suggestion} other {# suggestions}} from {reviewer}"
    },
    thinkingCompleteNewSuggestionCount: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.newSuggestionCount.non-final",
        defaultMessage: "{count, plural, one {# new suggestion} other {# new suggestions}} from {reviewer}"
    },
    thinkingCompleteSuggestionCountWithoutReviewer: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.suggestionCountWithoutReviewer.non-final",
        defaultMessage: "{count, plural, one {# suggestion} other {# suggestions}}"
    },
    thinkingCompleteNewSuggestionCountWithoutReviewer: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.newSuggestionCountWithoutReviewer.non-final",
        defaultMessage: "{count, plural, one {# new suggestion} other {# new suggestions}}"
    },
    thinkingCompleteReviewComplete: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.reviewComplete.non-final",
        defaultMessage: "Suggestions ready"
    },
    thinkingCompleteReviewCompleteUpdated: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.reviewCompleteUpdated.non-final",
        defaultMessage: "Review complete, view your suggestions."
    },
    thinkingCompleteNoSuggestions: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.noSuggestions.non-final",
        defaultMessage: "No suggestions found"
    },
    thinkingCompleteNoSuggestionsUpdated: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.noSuggestionsUpdated.non-final",
        defaultMessage: "Review complete. No suggestions found."
    },
    thinkingCompleteViewSuggestions: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.viewSuggestions.non-final",
        defaultMessage: "View"
    },
    thinkingCompleteClose: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.close.non-final",
        defaultMessage: "Close"
    },
    thinkingErrorTokenLimitExceeded: {
        id: "fabric.editor.ai.suggestions.thinkingError.tokenLimitExceeded.non-final",
        defaultMessage: "There\u2019s too much content to process."
    },
    teamworkGraphLabel: {
        id: "fabric.editor.ai.suggestions.teamworkGraphLabel.non-final",
        defaultMessage: "Teamwork Graph"
    }
});
module.exports["aiSuggestionsMessages"] = $41c05f11e4e9fb00$export$e4f30354a76c156b;

});

parcelRegister("djfAu", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $jaFVy = parcelRequire("jaFVy");


var $3k5Tv = parcelRequire("3k5Tv");

const $f0c3ebe4e6098611$export$a935cc97724bad0a = (api)=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "connectivity"
        ];
        $[0] = t0;
    } else t0 = $[0];
    return (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t0, $f0c3ebe4e6098611$var$_temp);
};
function $f0c3ebe4e6098611$var$_temp(t0) {
    const { connectivityState: connectivityState } = t0;
    return (0, $jaFVy.isOfflineMode)(connectivityState?.mode);
}
module.exports["useIsOffline"] = $f0c3ebe4e6098611$export$a935cc97724bad0a;

});

parcelRegister("3eyLF", function(module, exports) {
module.exports = new URL("InitialSuggestions.074ce463.svg", import.meta.url).toString();

});

parcelRegister("dZBvH", function(module, exports) {
module.exports = new URL("EmptySuggestionsDark.5dbf90a7.svg", import.meta.url).toString();

});

parcelRegister("d276e", function(module, exports) {
module.exports = new URL("EmptySuggestionsDoneDark.d79c82a3.svg", import.meta.url).toString();

});

parcelRegister("hDutP", function(module, exports) {
module.exports = new URL("EmptySuggestionsDoneLight.ec9817c3.svg", import.meta.url).toString();

});

parcelRegister("1VPsJ", function(module, exports) {
module.exports = new URL("EmptySuggestionsLight.926eb834.svg", import.meta.url).toString();

});

parcelRegister("anzFm", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ikV3b = parcelRequire("ikV3b");


var $f6wWZ = parcelRequire("f6wWZ");


var $6wOvs = parcelRequire("6wOvs");

const $6eaabb854842fb32$var$styles = {
    container: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _0jFU0VN91d _2Zuz6QNHnM _1ZnuxbNHnM"
};
const $6eaabb854842fb32$var$i18n = (0, $kSwu1.defineMessages)({
    preparingSuggestions: {
        id: "suggestions-panel.published.loading.preparing-suggestions",
        defaultMessage: "Preparing suggestions"
    }
});
const $6eaabb854842fb32$export$cec78ecaa5551c2d = 'suggestions-initial-loading';
const $6eaabb854842fb32$export$627bf25441769b75 = ()=>{
    const $ = (0, $bDgLe.c)(7);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            $6eaabb854842fb32$var$styles.container
        ]);
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ikV3b.MorphingShapeLoader), {
            testId: "suggestions-initial-loading-indicator",
            size: "large"
        });
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage($6eaabb854842fb32$var$i18n.preparingSuggestions);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6wWZ.EllipsesAnimation), {
            isAnimated: true
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "status",
            "data-testid": $6eaabb854842fb32$export$cec78ecaa5551c2d,
            className: t0
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wOvs.ShimmerText), {
            size: "medium"
        }, t2, t3));
        $[5] = t2;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
};
module.exports["SuggestionsInitialLoading"] = $6eaabb854842fb32$export$627bf25441769b75;

});

parcelRegister("ap8M1", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $6gGPb = parcelRequire("6gGPb");


var $kb1I3 = parcelRequire("kb1I3");


var $2gVZP = parcelRequire("2gVZP");


var $9AWgf = parcelRequire("9AWgf");

const $e50ba51a0500813d$var$styles = {
    container: "_1mT5xdHE3j _1ZB6UyTUhv _42Yu6BiZR3",
    card: "_0bjKvDyzSk _2Y7lL45zaO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _0KLXruwawV _2OUyjtFYNq",
    barRow: "_4c065U8HPE _39xV02N91d",
    placeholderAvatarSlot: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg"
};
const $e50ba51a0500813d$export$c1991469f51f91e2 = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { agent: agent, api: api, isAgentLoading: t1, startedAt: startedAt } = t0;
    const isAgentLoading = t1 === undefined ? false : t1;
    const t2 = agent?.name;
    let t3;
    if ($[0] !== isAgentLoading || $[1] !== t2) {
        t3 = {
            agentName: t2,
            isAgentLoading: isAgentLoading
        };
        $[0] = isAgentLoading;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const rotatingMessages = (0, $9AWgf.useSuggestionsLoadingMessages)(t3);
    const fireCancelledAnalytics = (0, $2gVZP.useCancelledAnalytics)(api?.analytics?.actions.fireAnalyticsEvent);
    let t4;
    if ($[3] !== api?.aiSuggestions?.actions || $[4] !== fireCancelledAnalytics) {
        t4 = ()=>{
            fireCancelledAnalytics();
            api?.aiSuggestions?.actions?.setThinkingState("idle");
        };
        $[3] = api?.aiSuggestions?.actions;
        $[4] = fireCancelledAnalytics;
        $[5] = t4;
    } else t4 = $[5];
    const handleStop = t4;
    const agentId = agent?.id;
    const agentNamedId = agent?.namedId;
    const agentIdentityAccountId = agent?.identityAccountId;
    let t5;
    bb0: {
        if (agentId) {
            let t6;
            if ($[6] !== agentId || $[7] !== agentIdentityAccountId || $[8] !== agentNamedId) {
                t6 = {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
                        agentId: agentId,
                        agentNamedId: agentNamedId,
                        agentIdentityAccountId: agentIdentityAccountId,
                        size: "small",
                        showBorder: false
                    })
                };
                $[6] = agentId;
                $[7] = agentIdentityAccountId;
                $[8] = agentNamedId;
                $[9] = t6;
            } else t6 = $[9];
            t5 = t6;
            break bb0;
        }
        if (isAgentLoading) {
            let t6;
            let t7;
            if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = (0, $hekY6.default)([
                    $e50ba51a0500813d$var$styles.placeholderAvatarSlot
                ]);
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                    appearance: "hexagon",
                    size: "small",
                    borderColor: "transparent",
                    testId: "suggestions-panel-preparing-agent-avatar"
                });
                $[10] = t6;
                $[11] = t7;
            } else {
                t6 = $[10];
                t7 = $[11];
            }
            let t8;
            if ($[12] !== t6) {
                t8 = {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                        className: t6
                    }, t7)
                };
                $[12] = t6;
                $[13] = t8;
            } else t8 = $[13];
            t5 = t8;
            break bb0;
        }
        t5 = undefined;
    }
    const firstMessage = t5;
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $e50ba51a0500813d$var$styles.container
        ]);
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            $e50ba51a0500813d$var$styles.card
        ]);
        t8 = (0, $hekY6.default)([
            $e50ba51a0500813d$var$styles.barRow
        ]);
        $[15] = t7;
        $[16] = t8;
    } else {
        t7 = $[15];
        t8 = $[16];
    }
    let t9;
    if ($[17] !== firstMessage || $[18] !== handleStop || $[19] !== rotatingMessages || $[20] !== startedAt) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "suggestions-panel-inline-loading-bar",
            className: t6
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "suggestions-panel-inline-loading-bar-card",
            className: t7
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t8
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kb1I3.RovoThinkingBar), {
            onStop: handleStop,
            useRotatingTitle: true,
            customRotatingMessages: rotatingMessages,
            startedAt: startedAt,
            firstMessage: firstMessage
        }))));
        $[17] = firstMessage;
        $[18] = handleStop;
        $[19] = rotatingMessages;
        $[20] = startedAt;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
};
module.exports["SuggestionsInlineLoadingBar"] = $e50ba51a0500813d$export$c1991469f51f91e2;

});

parcelRegister("9AWgf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $ffa1829aa7b4da51$export$19ffbb7c45d80824 = 4000;
const $ffa1829aa7b4da51$var$i18n = (0, $kSwu1.defineMessages)({
    analyzingWithAgent: {
        id: "suggestions-panel.loading-messages.analyzing-content-with-agent",
        defaultMessage: "{agentName} is analyzing"
    },
    preparingAgent: {
        id: "suggestions-panel.loading-messages.preparing-agent",
        defaultMessage: "Preparing agent"
    },
    // Fallback for the messages above, used when no agent handles the review.
    reviewing: {
        id: "suggestions-panel.loading-messages.reviewing",
        defaultMessage: "Rovo is reviewing your page"
    },
    mayTakeAFewMinutes: {
        id: "suggestions-panel.loading-messages.may-take-a-few-minutes",
        defaultMessage: "This may take a few minutes"
    },
    gatheringContext: {
        id: "suggestions-panel.loading-messages.gathering-context",
        defaultMessage: "Gathering context"
    },
    reviewingConsistency: {
        id: "suggestions-panel.loading-messages.reviewing-consistency",
        defaultMessage: "Reviewing consistency"
    },
    checkingWritingClarity: {
        id: "suggestions-panel.loading-messages.checking-writing-clarity",
        defaultMessage: "Checking writing clarity"
    },
    identifyingImprovements: {
        id: "suggestions-panel.loading-messages.identifying-improvements",
        defaultMessage: "Identifying improvements"
    },
    generatingSuggestions: {
        id: "suggestions-panel.loading-messages.generating-suggestions",
        defaultMessage: "Generating AI suggestions"
    },
    refiningSuggestions: {
        id: "suggestions-panel.loading-messages.refining-suggestions",
        defaultMessage: "Refining AI suggestions"
    },
    prioritizingSuggestions: {
        id: "suggestions-panel.loading-messages.prioritizing-suggestions",
        defaultMessage: "Prioritizing AI suggestions"
    }
});
function $ffa1829aa7b4da51$export$1a4b1aedd1814819(t0) {
    const $ = (0, $bDgLe.c)(35);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { agentName: agentName, isAgentLoading: t2 } = t1;
    const isAgentLoading = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t3;
    bb0: {
        if (!agentName && isAgentLoading) {
            let t4;
            if ($[2] !== formatMessage) {
                t4 = formatMessage($ffa1829aa7b4da51$var$i18n.preparingAgent);
                $[2] = formatMessage;
                $[3] = t4;
            } else t4 = $[3];
            let t5;
            if ($[4] !== t4) {
                t5 = [
                    t4
                ];
                $[4] = t4;
                $[5] = t5;
            } else t5 = $[5];
            t3 = t5;
            break bb0;
        }
        let t4;
        if ($[6] !== agentName || $[7] !== formatMessage) {
            t4 = agentName ? formatMessage($ffa1829aa7b4da51$var$i18n.analyzingWithAgent, {
                agentName: agentName
            }) : formatMessage($ffa1829aa7b4da51$var$i18n.reviewing);
            $[6] = agentName;
            $[7] = formatMessage;
            $[8] = t4;
        } else t4 = $[8];
        let t5;
        if ($[9] !== formatMessage) {
            t5 = formatMessage($ffa1829aa7b4da51$var$i18n.mayTakeAFewMinutes);
            $[9] = formatMessage;
            $[10] = t5;
        } else t5 = $[10];
        let t6;
        if ($[11] !== formatMessage) {
            t6 = formatMessage($ffa1829aa7b4da51$var$i18n.gatheringContext);
            $[11] = formatMessage;
            $[12] = t6;
        } else t6 = $[12];
        let t7;
        if ($[13] !== formatMessage) {
            t7 = formatMessage($ffa1829aa7b4da51$var$i18n.reviewingConsistency);
            $[13] = formatMessage;
            $[14] = t7;
        } else t7 = $[14];
        let t8;
        if ($[15] !== formatMessage) {
            t8 = formatMessage($ffa1829aa7b4da51$var$i18n.checkingWritingClarity);
            $[15] = formatMessage;
            $[16] = t8;
        } else t8 = $[16];
        let t9;
        if ($[17] !== formatMessage) {
            t9 = formatMessage($ffa1829aa7b4da51$var$i18n.identifyingImprovements);
            $[17] = formatMessage;
            $[18] = t9;
        } else t9 = $[18];
        let t10;
        if ($[19] !== formatMessage) {
            t10 = formatMessage($ffa1829aa7b4da51$var$i18n.generatingSuggestions);
            $[19] = formatMessage;
            $[20] = t10;
        } else t10 = $[20];
        let t11;
        if ($[21] !== formatMessage) {
            t11 = formatMessage($ffa1829aa7b4da51$var$i18n.refiningSuggestions);
            $[21] = formatMessage;
            $[22] = t11;
        } else t11 = $[22];
        let t12;
        if ($[23] !== formatMessage) {
            t12 = formatMessage($ffa1829aa7b4da51$var$i18n.prioritizingSuggestions);
            $[23] = formatMessage;
            $[24] = t12;
        } else t12 = $[24];
        let t13;
        if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t4 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7 || $[32] !== t8 || $[33] !== t9) {
            t13 = [
                t4,
                t5,
                t6,
                t7,
                t8,
                t9,
                t10,
                t11,
                t12
            ];
            $[25] = t10;
            $[26] = t11;
            $[27] = t12;
            $[28] = t4;
            $[29] = t5;
            $[30] = t6;
            $[31] = t7;
            $[32] = t8;
            $[33] = t9;
            $[34] = t13;
        } else t13 = $[34];
        t3 = t13;
    }
    return t3;
}
function $ffa1829aa7b4da51$export$cac96de102c09bbf(messages, startedAt) {
    const lastIndex = Math.max(0, messages.length - 1);
    const indexFromStart = ()=>{
        if (startedAt == null) return 0;
        const elapsed = Math.max(0, Date.now() - startedAt);
        return Math.min(lastIndex, Math.floor(elapsed / $ffa1829aa7b4da51$export$19ffbb7c45d80824));
    };
    const [index, setIndex] = (0, $cozmU.useState)(indexFromStart);
    const indexRef = (0, $cozmU.useRef)(index);
    indexRef.current = index;
    (0, $cozmU.useEffect)(()=>{
        if (indexRef.current >= lastIndex) return;
        const interval = setInterval(()=>{
            const next = indexRef.current + 1;
            indexRef.current = next;
            setIndex(next);
            if (next >= lastIndex) clearInterval(interval);
        }, $ffa1829aa7b4da51$export$19ffbb7c45d80824);
        return ()=>clearInterval(interval);
    }, [
        lastIndex,
        startedAt
    ]);
    return messages[Math.min(index, lastIndex)] ?? '';
}
module.exports["useSuggestionsLoadingMessages"] = $ffa1829aa7b4da51$export$1a4b1aedd1814819;
module.exports["useRotatingLoadingMessage"] = $ffa1829aa7b4da51$export$cac96de102c09bbf;

});

parcelRegister("hkoM6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $ikV3b = parcelRequire("ikV3b");


var $1kxki = parcelRequire("1kxki");


var $f6wWZ = parcelRequire("f6wWZ");


var $6wOvs = parcelRequire("6wOvs");


var $2gVZP = parcelRequire("2gVZP");


var $8JlGf = parcelRequire("8JlGf");


var $9AWgf = parcelRequire("9AWgf");

const $679cc8bdeab37cb4$var$styles = {
    container: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _0jFU0VN91d _2Zuz6QNHnM _1ZnuxbNHnM",
    loadingContainer: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _39xV02gE1Q"
};
const $679cc8bdeab37cb4$var$i18n = (0, $kSwu1.defineMessages)({
    cancelButton: {
        id: "suggestions-panel.loading-state.cancel-button",
        defaultMessage: "Stop suggesting"
    }
});
const $679cc8bdeab37cb4$export$19552ae55ff281f0 = (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { agentName: agentName, api: api, isAgentLoading: isAgentLoading, startedAt: startedAt, rotationStartedAt: rotationStartedAt, progressTarget: progressTarget } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== agentName || $[1] !== isAgentLoading) {
        t1 = {
            agentName: agentName,
            isAgentLoading: isAgentLoading
        };
        $[0] = agentName;
        $[1] = isAgentLoading;
        $[2] = t1;
    } else t1 = $[2];
    const loadingMessages = (0, $9AWgf.useSuggestionsLoadingMessages)(t1);
    const loadingMessage = (0, $9AWgf.useRotatingLoadingMessage)(loadingMessages, rotationStartedAt ?? startedAt);
    let t2;
    if ($[3] !== progressTarget || $[4] !== startedAt) {
        t2 = {
            startedAt: startedAt,
            progressTarget: progressTarget
        };
        $[3] = progressTarget;
        $[4] = startedAt;
        $[5] = t2;
    } else t2 = $[5];
    const progress = (0, $8JlGf.useSuggestionsLoadingProgress)(t2);
    const fireCancelledAnalytics = (0, $2gVZP.useCancelledAnalytics)(api?.analytics?.actions.fireAnalyticsEvent);
    let t3;
    if ($[6] !== api?.aiSuggestions?.actions || $[7] !== fireCancelledAnalytics) {
        t3 = ()=>{
            fireCancelledAnalytics();
            api?.aiSuggestions?.actions?.setThinkingState("idle");
        };
        $[6] = api?.aiSuggestions?.actions;
        $[7] = fireCancelledAnalytics;
        $[8] = t3;
    } else t3 = $[8];
    const handleCancel = t3;
    let t4;
    let t5;
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $679cc8bdeab37cb4$var$styles.container
        ]);
        t5 = (0, $hekY6.default)([
            $679cc8bdeab37cb4$var$styles.loadingContainer
        ]);
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ikV3b.MorphingShapeLoader), {
            testId: "suggestions-panel-thinking-indicator",
            size: "large"
        });
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else {
        t4 = $[9];
        t5 = $[10];
        t6 = $[11];
    }
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6wWZ.EllipsesAnimation), {
            isAnimated: true
        });
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== loadingMessage) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wOvs.ShimmerText), {
            size: "medium"
        }, loadingMessage, t7);
        $[13] = loadingMessage;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== loadingMessage || $[16] !== progress) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1kxki.RainbowProgressBar), {
            testId: "suggestions-panel-progress-bar",
            label: loadingMessage,
            progress: progress,
            appearance: "static-rainbow"
        });
        $[15] = loadingMessage;
        $[16] = progress;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== t8 || $[19] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t5
        }, t6, t8, t9);
        $[18] = t8;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== formatMessage) {
        t11 = formatMessage($679cc8bdeab37cb4$var$i18n.cancelButton);
        $[21] = formatMessage;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== handleCancel || $[24] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: handleCancel
        }, t11);
        $[23] = handleCancel;
        $[24] = t11;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== t10 || $[27] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "suggestions-panel-loading-state",
            className: t4
        }, t10, t12);
        $[26] = t10;
        $[27] = t12;
        $[28] = t13;
    } else t13 = $[28];
    return t13;
};
module.exports["SuggestionsLoadingState"] = $679cc8bdeab37cb4$export$19552ae55ff281f0;

});

parcelRegister("8JlGf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $63e2dd980ca0fd67$var$ESTIMATED_DURATION_MS = 30000;
function $63e2dd980ca0fd67$export$4569a5255d6688ce(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { startedAt: startedAt, progressTarget: progressTarget } = t0;
    const [fallbackTarget] = (0, $cozmU.useState)($63e2dd980ca0fd67$var$_temp);
    const target = progressTarget ?? fallbackTarget;
    let t1;
    if ($[0] !== startedAt || $[1] !== target) {
        t1 = ()=>startedAt == null ? 0 : Math.min(1, Math.max(0, Date.now() - startedAt) / $63e2dd980ca0fd67$var$ESTIMATED_DURATION_MS) * target;
        $[0] = startedAt;
        $[1] = target;
        $[2] = t1;
    } else t1 = $[2];
    const [progress, setProgress] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[3] !== startedAt || $[4] !== target) {
        t2 = ()=>{
            const sessionStart = startedAt ?? Date.now();
            let frameId;
            const tick = ()=>{
                const fraction = Math.min(1, Math.max(0, Date.now() - sessionStart) / $63e2dd980ca0fd67$var$ESTIMATED_DURATION_MS);
                setProgress(fraction * target);
                if (fraction < 1) frameId = requestAnimationFrame(tick);
            };
            frameId = requestAnimationFrame(tick);
            return ()=>cancelAnimationFrame(frameId);
        };
        t3 = [
            startedAt,
            target
        ];
        $[3] = startedAt;
        $[4] = target;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    return progress;
}
function $63e2dd980ca0fd67$var$_temp() {
    return 85 + Math.random() * 10;
}
module.exports["useSuggestionsLoadingProgress"] = $63e2dd980ca0fd67$export$4569a5255d6688ce;

});

parcelRegister("H1gk2", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1l0kj = parcelRequire("1l0kj");


var $hBYtq = parcelRequire("hBYtq");


var $4aRua = parcelRequire("4aRua");


var $dinVW = parcelRequire("dinVW");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $fxbF1 = parcelRequire("fxbF1");


var $4efpo = parcelRequire("4efpo");


var $6TaGl = parcelRequire("6TaGl");


var $93fnf = parcelRequire("93fnf");


var $c8bBH = parcelRequire("c8bBH");


var $aCJyI = parcelRequire("aCJyI");


var $lpNn5 = parcelRequire("lpNn5");


var $gVCFw = parcelRequire("gVCFw");


var $6mKj3 = parcelRequire("6mKj3");


var $2gVZP = parcelRequire("2gVZP");


var $fIL3E = parcelRequire("fIL3E");


var $gzxxG = parcelRequire("gzxxG");


var $cQk6K = parcelRequire("cQk6K");

const $293a55cbb0ff13fd$var$i18n = (0, $kSwu1.defineMessages)({
    accept: {
        id: "suggestions-panel.accept",
        defaultMessage: "Accept"
    },
    discard: {
        id: "suggestions-panel.discard",
        defaultMessage: "Discard"
    },
    goodSuggestion: {
        id: "suggestions-panel.good-suggestion",
        defaultMessage: "Good suggestion"
    },
    badSuggestion: {
        id: "suggestions-panel.bad-suggestion",
        defaultMessage: "Bad suggestion"
    },
    viewSuggestion: {
        id: "suggestions-panel.view-suggestion",
        defaultMessage: "View suggestion"
    },
    dismiss: {
        id: "suggestions-panel.dismiss",
        defaultMessage: "Dismiss"
    },
    restrictedLabel: {
        id: "suggestions-panel.restricted-label",
        defaultMessage: "Restricted"
    },
    restrictedTooltip: {
        id: "suggestions-panel.restricted-tooltip",
        defaultMessage: "Only editors with access to the source can see this suggestion"
    },
    moreActions: {
        id: "suggestions-panel.more-actions",
        defaultMessage: "More actions"
    }
});
const $293a55cbb0ff13fd$export$2c259a0335a7d687 = 'suggestion-item-description-shimmer'; // Shimmer applied to the description while the suggestion is regenerating.
// Copied from the editor's SuggestionCard (itself a copy of
// rovo-platform-ui-components' ShimmerText) rather than using `ShimmerText`
// directly: that component hardcodes its own Text size/colour, which would
// change the description's typography. This wraps the existing Text untouched.
const $293a55cbb0ff13fd$var$shimmerAnimation = null;
const $293a55cbb0ff13fd$var$shimmerGradient = null;
const $293a55cbb0ff13fd$var$styles = {
    item: "_0bjKvDyzSk _2mHwu88HPE _23rrnHo10F _2V7sgONvrM _3hxITi6wH8 _3vBAKHjOvk _2Y7lL45zaO _4c065U5zaO _39xV02N91d _24h04i2Njc _0KLXruwawV _0wOv4Q7zJH _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNL7p2s _37wbyu7p2s _2fwxA57p2s _1ubuxonXvL _1NDpvb6wH8 _2wtOC9vc3e _34b3D2FQfX _1eOmH6wawV _3fSdSTFYNq _3sFUREDdj4 _3gzVzLwawV",
    itemSelected: "_23rrnHo10F _0wOv4QIZbP _0KLXruwawV _2OUyjtGk8v _1eOmH6wawV _3fSdSTGk8v _3sFUREDdj4 _3gzVzLwawV",
    itemMotion: "_23rrnHQVUb",
    detailsToggle: "_30huDKYbGa _4c065UPgdg _2Y7lL4Pgdg _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYzKGUX _0KLXrujOvk _0wOv4Q7zJH",
    cardRow: "_39xV02N91d",
    cardActions: "_39xV02N91d _480PPf9PHR",
    detailsContainer: "_0bjKvD8fU6 _4c065U8HPE _39xV02N91d _0KLXrumhAQ _3CkH9oJW0e _3OqcjTzSkR _1DJ2rVEHne",
    detailsContent: "_2Y7lL48HPE",
    privateMetadata: "_3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT",
    restrictedMetadata: "_4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _0wOv4Q18ZR _3iDTPbQ4SZ",
    restrictedContent: "_0hPCNLDIqT _17lj8pPgdg _3iDTPbkfkE _2iEGP2emYi _2xTnZxt7Uv _0GTcwRt7Uv _3Z9K0wLrT7 _1kOSYtLM0u _0qk6IKxt7V _1RrJLit2nV",
    restrictedContentExpanded: "_17lj8p1Y8M _2iEGP2cMcx _2xTnZxPgdg _0GTcwRPgdg",
    restrictedLabel: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIPgdg _1YKVNsdnbC _3Z9K0wLrT7 _1kOSYt9v2r _0qk6IKjwM9 _1ANEUSLRg7",
    restrictedLabelExpanded: "_1YKVNs7dHp"
};
const $293a55cbb0ff13fd$export$18af743539b68cfc = (t0)=>{
    const $ = (0, $bDgLe.c)(101);
    const { suggestion: suggestion, fireAnalyticsEvent: fireAnalyticsEvent, isSelected: t1, isStackAnimating: t2, isRegenerating: t3, isActionDisabled: t4, onSelect: onSelect, onAccept: onAccept, onDiscard: onDiscard, onDismiss: onDismiss, onView: onView, onGoodSuggestion: onGoodSuggestion, onBadSuggestion: onBadSuggestion, onToggleDeletedDiffs: onToggleDeletedDiffs } = t0;
    const isSelected = t1 === undefined ? false : t1;
    const isStackAnimating = t2 === undefined ? false : t2;
    const isRegenerating = t3 === undefined ? false : t3;
    const isActionDisabledProp = t4 === undefined ? false : t4;
    const isActionDisabled = isRegenerating || isActionDisabledProp;
    const ref = (0, $cozmU.useRef)(null);
    let t5;
    let t6;
    if ($[0] !== isSelected || $[1] !== isStackAnimating) {
        t5 = ()=>{
            if (isStackAnimating && (0, $6mKj3.isExperimentEnabled)("platform_editor_ai_content_suggested_edits_labs")) return;
            if (isSelected) ref.current?.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
        };
        t6 = [
            isSelected,
            isStackAnimating
        ];
        $[0] = isSelected;
        $[1] = isStackAnimating;
        $[2] = t5;
        $[3] = t6;
    } else {
        t5 = $[2];
        t6 = $[3];
    }
    (0, $cozmU.useEffect)(t5, t6);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isDetailsExpanded, setIsDetailsExpanded] = (0, $cozmU.useState)(false);
    const actionsRef = (0, $cozmU.useRef)(null);
    const wasDetailsExpanded = (0, $cozmU.useRef)(isDetailsExpanded);
    let t7;
    let t8;
    if ($[4] !== isDetailsExpanded || $[5] !== isSelected) {
        t7 = ()=>{
            if (isSelected && !wasDetailsExpanded.current && isDetailsExpanded) actionsRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
            wasDetailsExpanded.current = isDetailsExpanded;
        };
        t8 = [
            isSelected,
            isDetailsExpanded
        ];
        $[4] = isDetailsExpanded;
        $[5] = isSelected;
        $[6] = t7;
        $[7] = t8;
    } else {
        t7 = $[6];
        t8 = $[7];
    }
    (0, $cozmU.useEffect)(t7, t8);
    const [isRestrictedHovered, setIsRestrictedHovered] = (0, $cozmU.useState)(false);
    const fireReasoningViewedAnalytics = (0, $2gVZP.useReasoningViewedAnalytics)(fireAnalyticsEvent);
    const isStale = suggestion.status === "STALE";
    const [isHidingDeletedDiffs, setIsHidingDeletedDiffs] = (0, $cozmU.useState)(false);
    let t10;
    let t9;
    if ($[8] !== isSelected) {
        t9 = ()=>{
            if (!isSelected) setIsHidingDeletedDiffs(false);
        };
        t10 = [
            isSelected
        ];
        $[8] = isSelected;
        $[9] = t10;
        $[10] = t9;
    } else {
        t10 = $[9];
        t9 = $[10];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[11] !== fireReasoningViewedAnalytics || $[12] !== isDetailsExpanded || $[13] !== suggestion) {
        t11 = (e)=>{
            e.stopPropagation();
            if (!isDetailsExpanded) fireReasoningViewedAnalytics(suggestion);
            setIsDetailsExpanded($293a55cbb0ff13fd$var$_temp);
        };
        $[11] = fireReasoningViewedAnalytics;
        $[12] = isDetailsExpanded;
        $[13] = suggestion;
        $[14] = t11;
    } else t11 = $[14];
    const handleDetailsToggle = t11;
    let t12;
    if ($[15] !== isSelected || $[16] !== onSelect || $[17] !== suggestion.id) {
        t12 = ()=>{
            if (isSelected) return;
            onSelect?.(suggestion.id);
        };
        $[15] = isSelected;
        $[16] = onSelect;
        $[17] = suggestion.id;
        $[18] = t12;
    } else t12 = $[18];
    const handleSelect = t12;
    let t13;
    if ($[19] !== isHidingDeletedDiffs || $[20] !== onAccept || $[21] !== suggestion.id) {
        t13 = ()=>onAccept?.(suggestion.id, isHidingDeletedDiffs);
        $[19] = isHidingDeletedDiffs;
        $[20] = onAccept;
        $[21] = suggestion.id;
        $[22] = t13;
    } else t13 = $[22];
    const handleAccept = t13;
    let t14;
    if ($[23] !== onDiscard || $[24] !== suggestion.id) {
        t14 = ()=>onDiscard?.(suggestion.id);
        $[23] = onDiscard;
        $[24] = suggestion.id;
        $[25] = t14;
    } else t14 = $[25];
    const handleDiscard = t14;
    let t15;
    if ($[26] !== onDismiss || $[27] !== suggestion.id) {
        t15 = ()=>onDismiss?.(suggestion.id);
        $[26] = onDismiss;
        $[27] = suggestion.id;
        $[28] = t15;
    } else t15 = $[28];
    const handleDismiss = t15;
    let t16;
    if ($[29] !== onView || $[30] !== suggestion.id) {
        t16 = ()=>onView?.(suggestion.id);
        $[29] = onView;
        $[30] = suggestion.id;
        $[31] = t16;
    } else t16 = $[31];
    const handleView = t16;
    let t17;
    if ($[32] !== onGoodSuggestion || $[33] !== suggestion.id) {
        t17 = ()=>onGoodSuggestion?.(suggestion.id);
        $[32] = onGoodSuggestion;
        $[33] = suggestion.id;
        $[34] = t17;
    } else t17 = $[34];
    const handleGoodSuggestion = t17;
    let t18;
    if ($[35] !== onBadSuggestion || $[36] !== suggestion.id) {
        t18 = ()=>onBadSuggestion?.(suggestion.id);
        $[35] = onBadSuggestion;
        $[36] = suggestion.id;
        $[37] = t18;
    } else t18 = $[37];
    const handleBadSuggestion = t18;
    let t19;
    if ($[38] !== isHidingDeletedDiffs || $[39] !== onToggleDeletedDiffs || $[40] !== suggestion.id) {
        t19 = ()=>{
            const updatedHideDeletedDiffs = !isHidingDeletedDiffs;
            setIsHidingDeletedDiffs(updatedHideDeletedDiffs);
            onToggleDeletedDiffs?.(suggestion.id, updatedHideDeletedDiffs);
        };
        $[38] = isHidingDeletedDiffs;
        $[39] = onToggleDeletedDiffs;
        $[40] = suggestion.id;
        $[41] = t19;
    } else t19 = $[41];
    const handleToggleDeletedDiffs = t19;
    let t20;
    if ($[42] !== formatMessage || $[43] !== isActionDisabled) {
        t20 = (t21)=>{
            const { triggerRef: triggerRef, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, onClick: onClick, isSelected: isMenuSelected } = t21;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ref: triggerRef,
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isDisabled: isActionDisabled,
                isSelected: isMenuSelected,
                onClick: onClick,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: formatMessage($293a55cbb0ff13fd$var$i18n.moreActions),
                isTooltipDisabled: false,
                appearance: "subtle",
                spacing: "default"
            });
        };
        $[42] = formatMessage;
        $[43] = isActionDisabled;
        $[44] = t20;
    } else t20 = $[44];
    const renderMoreOptionsTrigger = t20;
    const isInsight = suggestion.actionKind === "INFORMATIONAL";
    const hasDetails = Boolean(suggestion.reasoning || suggestion.sources?.length);
    const hasSources = Boolean(suggestion.sources?.length);
    let t21;
    if ($[45] !== formatMessage || $[46] !== hasSources || $[47] !== isRestrictedHovered) {
        t21 = hasSources && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "top",
            content: formatMessage($293a55cbb0ff13fd$var$i18n.restrictedTooltip),
            ignoreTooltipPointerEvents: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "suggestion-restricted-metadata",
            onMouseEnter: ()=>setIsRestrictedHovered(true),
            onMouseLeave: ()=>setIsRestrictedHovered(false),
            onFocus: ()=>setIsRestrictedHovered(true),
            onBlur: ()=>setIsRestrictedHovered(false),
            className: (0, $hekY6.default)([
                $293a55cbb0ff13fd$var$styles.privateMetadata,
                $293a55cbb0ff13fd$var$styles.restrictedMetadata
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aCJyI.default), {
            appearance: "neutral"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $293a55cbb0ff13fd$var$styles.restrictedContent,
                isRestrictedHovered && $293a55cbb0ff13fd$var$styles.restrictedContentExpanded
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
            label: "",
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $293a55cbb0ff13fd$var$styles.restrictedLabel,
                isRestrictedHovered && $293a55cbb0ff13fd$var$styles.restrictedLabelExpanded
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "span",
            size: "small",
            weight: "regular",
            color: "color.text.subtle"
        }, formatMessage($293a55cbb0ff13fd$var$i18n.restrictedLabel)))))));
        $[45] = formatMessage;
        $[46] = hasSources;
        $[47] = isRestrictedHovered;
        $[48] = t21;
    } else t21 = $[48];
    const restrictedMetadata = t21;
    const t22 = isSelected && $293a55cbb0ff13fd$var$styles.itemSelected;
    let t23;
    if ($[49] !== t22) {
        t23 = (0, $hekY6.default)([
            $293a55cbb0ff13fd$var$styles.item,
            t22,
            $293a55cbb0ff13fd$var$styles.itemMotion
        ]);
        $[49] = t22;
        $[50] = t23;
    } else t23 = $[50];
    let t24;
    if ($[51] !== isRegenerating || $[52] !== suggestion.description) {
        t24 = isRegenerating ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": $293a55cbb0ff13fd$export$2c259a0335a7d687,
            className: (0, $hekY6.default)([
                "_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p",
            size: "medium",
            weight: "medium"
        }, suggestion.description)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p",
            size: "medium",
            weight: "medium"
        }, suggestion.description);
        $[51] = isRegenerating;
        $[52] = suggestion.description;
        $[53] = t24;
    } else t24 = $[53];
    let t25;
    if ($[54] !== formatMessage || $[55] !== handleDetailsToggle || $[56] !== hasDetails || $[57] !== isDetailsExpanded || $[58] !== isRegenerating || $[59] !== isSelected || $[60] !== restrictedMetadata || $[61] !== suggestion.reasoning || $[62] !== suggestion.sources) {
        t25 = isSelected && hasDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100",
            xcss: $293a55cbb0ff13fd$var$styles.cardRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            xcss: $293a55cbb0ff13fd$var$styles.cardRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $293a55cbb0ff13fd$var$styles.detailsToggle,
            onClick: handleDetailsToggle,
            isDisabled: isRegenerating,
            "aria-expanded": isDetailsExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            as: "span",
            space: "space.075",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium",
            color: "inherit"
        }, formatMessage((0, $gVCFw.aiSuggestionsMessages).cardDetailsButtonLabel)), isDetailsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: "",
            size: "small"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, restrictedMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gzxxG.SuggestionItemSourceAppStack), {
            sources: suggestion.sources
        }))), isDetailsExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $293a55cbb0ff13fd$var$styles.detailsContainer,
            space: "space.250"
        }, suggestion.reasoning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $293a55cbb0ff13fd$var$styles.detailsContent
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p",
            color: "color.text.subtle"
        }, suggestion.reasoning)), !!suggestion.sources?.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cQk6K.SuggestionItemSources), {
            sources: suggestion.sources
        })));
        $[54] = formatMessage;
        $[55] = handleDetailsToggle;
        $[56] = hasDetails;
        $[57] = isDetailsExpanded;
        $[58] = isRegenerating;
        $[59] = isSelected;
        $[60] = restrictedMetadata;
        $[61] = suggestion.reasoning;
        $[62] = suggestion.sources;
        $[63] = t25;
    } else t25 = $[63];
    let t26;
    if ($[64] !== t24 || $[65] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150",
            xcss: $293a55cbb0ff13fd$var$styles.cardRow
        }, t24, t25);
        $[64] = t24;
        $[65] = t25;
        $[66] = t26;
    } else t26 = $[66];
    let t27;
    if ($[67] !== formatMessage || $[68] !== handleAccept || $[69] !== handleBadSuggestion || $[70] !== handleDiscard || $[71] !== handleDismiss || $[72] !== handleGoodSuggestion || $[73] !== handleToggleDeletedDiffs || $[74] !== handleView || $[75] !== isActionDisabled || $[76] !== isHidingDeletedDiffs || $[77] !== isInsight || $[78] !== isSelected || $[79] !== isStale || $[80] !== onBadSuggestion || $[81] !== onGoodSuggestion || $[82] !== onToggleDeletedDiffs || $[83] !== onView || $[84] !== renderMoreOptionsTrigger || $[85] !== suggestion.createdByAgent || $[86] !== suggestion.createdByUser) {
        t27 = isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            ref: actionsRef,
            alignBlock: "center",
            spread: "space-between",
            xcss: $293a55cbb0ff13fd$var$styles.cardActions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fIL3E.SuggestionAgentIdentity), {
            agent: suggestion.createdByAgent,
            user: suggestion.createdByUser
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, onView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleView,
            isDisabled: isActionDisabled
        }, formatMessage($293a55cbb0ff13fd$var$i18n.viewSuggestion)) : isInsight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: handleDismiss,
            isDisabled: isActionDisabled
        }, formatMessage($293a55cbb0ff13fd$var$i18n.dismiss)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (onToggleDeletedDiffs || onGoodSuggestion || onBadSuggestion) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            placement: "bottom-end",
            trigger: renderMoreOptionsTrigger
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, onToggleDeletedDiffs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))), {
                label: ""
            }),
            onClick: handleToggleDeletedDiffs
        }, isHidingDeletedDiffs ? formatMessage((0, $gVCFw.aiSuggestionsMessages).cardShowDeletedDiffsLabel) : formatMessage((0, $gVCFw.aiSuggestionsMessages).cardHideDeletedDiffsLabel)), onGoodSuggestion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
                label: ""
            }),
            onClick: handleGoodSuggestion
        }, formatMessage($293a55cbb0ff13fd$var$i18n.goodSuggestion)), onBadSuggestion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
                label: ""
            }),
            onClick: handleBadSuggestion
        }, formatMessage($293a55cbb0ff13fd$var$i18n.badSuggestion)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: isStale ? "primary" : "subtle",
            onClick: handleDiscard,
            isDisabled: isActionDisabled
        }, formatMessage($293a55cbb0ff13fd$var$i18n.discard)), !isStale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleAccept,
            isDisabled: isActionDisabled
        }, formatMessage($293a55cbb0ff13fd$var$i18n.accept)))));
        $[67] = formatMessage;
        $[68] = handleAccept;
        $[69] = handleBadSuggestion;
        $[70] = handleDiscard;
        $[71] = handleDismiss;
        $[72] = handleGoodSuggestion;
        $[73] = handleToggleDeletedDiffs;
        $[74] = handleView;
        $[75] = isActionDisabled;
        $[76] = isHidingDeletedDiffs;
        $[77] = isInsight;
        $[78] = isSelected;
        $[79] = isStale;
        $[80] = onBadSuggestion;
        $[81] = onGoodSuggestion;
        $[82] = onToggleDeletedDiffs;
        $[83] = onView;
        $[84] = renderMoreOptionsTrigger;
        $[85] = suggestion.createdByAgent;
        $[86] = suggestion.createdByUser;
        $[87] = t27;
    } else t27 = $[87];
    let t28;
    if ($[88] !== isSelected || $[89] !== restrictedMetadata || $[90] !== suggestion.createdByAgent || $[91] !== suggestion.createdByUser || $[92] !== suggestion.sources) {
        t28 = !isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            xcss: $293a55cbb0ff13fd$var$styles.cardRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fIL3E.SuggestionAgentIdentity), {
            agent: suggestion.createdByAgent,
            user: suggestion.createdByUser
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, restrictedMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gzxxG.SuggestionItemSourceAppStack), {
            sources: suggestion.sources
        })));
        $[88] = isSelected;
        $[89] = restrictedMetadata;
        $[90] = suggestion.createdByAgent;
        $[91] = suggestion.createdByUser;
        $[92] = suggestion.sources;
        $[93] = t28;
    } else t28 = $[93];
    let t29;
    if ($[94] !== handleSelect || $[95] !== isSelected || $[96] !== t23 || $[97] !== t26 || $[98] !== t27 || $[99] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            ref: ref,
            onClick: handleSelect,
            "aria-pressed": isSelected,
            className: t23
        }, t26, t27, t28);
        $[94] = handleSelect;
        $[95] = isSelected;
        $[96] = t23;
        $[97] = t26;
        $[98] = t27;
        $[99] = t28;
        $[100] = t29;
    } else t29 = $[100];
    return t29;
};
function $293a55cbb0ff13fd$var$_temp(prev) {
    return !prev;
}
module.exports["SuggestionItem"] = $293a55cbb0ff13fd$export$18af743539b68cfc;

});

parcelRegister("fIL3E", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $7zsi1 = parcelRequire("7zsi1");


var $gVCFw = parcelRequire("gVCFw");


var $bUd6P = parcelRequire("bUd6P");


var $lpNn5 = parcelRequire("lpNn5");


var $fED1k = parcelRequire("fED1k");

// group). Centering the agent avatar within `stack`'s exact `space.300` box cancels that margin out,
// so the visible hex icon — not `Avatar`'s larger margin box — lines up with `stack`'s edges.
const $6168efd072558176$var$styles = {
    stack: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS _0jFU0VNHnM _39xV02NHnM",
    userBadge: "_1mT5xdWVPG _1ZB6UyJ2Cl _1OKFqYJ2Cl _3iDTPbQ4SZ _1VJPca8SLj _0yKXXapeI4"
}; /** Renders the compact Rovo identity used when no agent avatar is available. */ 
function $6168efd072558176$var$RovoIdentity() {
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $gVCFw.aiSuggestionsMessages).cardRovoAuthorLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bUd6P.RovoHexIcon), {
            label: t0,
            size: "small"
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
}
function $6168efd072558176$var$AuthorsTooltip(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { agentName: agentName, children: children, userName: userName } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== agentName || $[1] !== formatMessage || $[2] !== userName) {
        t1 = userName ? formatMessage((0, $gVCFw.aiSuggestionsMessages).cardAuthorsTooltipLabel, {
            agentName: agentName,
            userName: userName
        }) : agentName;
        $[0] = agentName;
        $[1] = formatMessage;
        $[2] = userName;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t1,
            ignoreTooltipPointerEvents: true,
            position: "bottom"
        }, children);
        $[4] = children;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} /** Renders the agent and user identities associated with a suggestion. */ 
function $6168efd072558176$export$17e466db07db7ac6(t0) {
    const $ = (0, $bDgLe.c)(24);
    const { agent: agent, user: user } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    let validAgent;
    let validUser;
    if ($[0] !== agent || $[1] !== formatMessage || $[2] !== user) {
        const agentName = agent?.name?.trim();
        let t2;
        if ($[6] !== user?.name) {
            t2 = user?.name?.trim();
            $[6] = user?.name;
            $[7] = t2;
        } else t2 = $[7];
        const userName = t2;
        validAgent = agent?.accountId && agentName ? {
            name: agentName,
            picture: agent.picture?.trim() || undefined
        } : undefined;
        let t3;
        if ($[8] !== user || $[9] !== userName) {
            t3 = user?.accountId && userName ? {
                name: userName,
                picture: user.picture?.trim() || undefined
            } : undefined;
            $[8] = user;
            $[9] = userName;
            $[10] = t3;
        } else t3 = $[10];
        validUser = t3;
        t1 = validAgent ? (0, $fED1k.hasAgentVendorIcon)(validAgent.name) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "hexagon",
            borderColor: "transparent",
            label: validAgent.name,
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zsi1.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fED1k.AgentVendorIcon), {
            agentName: validAgent.name,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null)
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "hexagon",
            borderColor: "transparent",
            label: validAgent.name,
            name: validAgent.name,
            size: "small",
            src: validAgent.picture
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "hexagon",
            borderColor: "transparent",
            label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardRovoAuthorLabel),
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zsi1.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6168efd072558176$var$RovoIdentity, null)));
        $[0] = agent;
        $[1] = formatMessage;
        $[2] = user;
        $[3] = t1;
        $[4] = validAgent;
        $[5] = validUser;
    } else {
        t1 = $[3];
        validAgent = $[4];
        validUser = $[5];
    }
    const agentSlot = t1;
    let t2;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $6168efd072558176$var$styles.stack
        ]);
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== validUser) {
        t3 = validUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "suggestion-agent-identity-user-badge",
            className: (0, $hekY6.default)([
                $6168efd072558176$var$styles.userBadge
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            label: validUser.name,
            name: validUser.name,
            size: "small",
            src: validUser.picture
        }));
        $[12] = validUser;
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== agentSlot || $[15] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t2
        }, agentSlot, t3);
        $[14] = agentSlot;
        $[15] = t3;
        $[16] = t4;
    } else t4 = $[16];
    const authorAvatars = t4;
    let t5;
    if ($[17] !== formatMessage || $[18] !== validAgent?.name) {
        t5 = validAgent?.name ?? formatMessage((0, $gVCFw.aiSuggestionsMessages).cardRovoAuthorLabel);
        $[17] = formatMessage;
        $[18] = validAgent?.name;
        $[19] = t5;
    } else t5 = $[19];
    const t6 = validUser?.name;
    let t7;
    if ($[20] !== authorAvatars || $[21] !== t5 || $[22] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6168efd072558176$var$AuthorsTooltip, {
            agentName: t5,
            userName: t6
        }, authorAvatars);
        $[20] = authorAvatars;
        $[21] = t5;
        $[22] = t6;
        $[23] = t7;
    } else t7 = $[23];
    return t7;
}
module.exports["SuggestionAgentIdentity"] = $6168efd072558176$export$17e466db07db7ac6;

});

parcelRegister("fED1k", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $a4f8945af63a0707$var$SMALL_AVATAR_SIZE = 24;
const $a4f8945af63a0707$var$getVendorBrand = (agentName)=>{
    const knownNames = [
        {
            name: 'Claude Code',
            brand: 'claude'
        },
        {
            name: 'Claude',
            brand: 'claude'
        },
        {
            name: 'ChatGPT',
            brand: 'chatgpt'
        },
        {
            name: 'Codex',
            brand: 'chatgpt'
        }
    ];
    return knownNames.find(({ name: name })=>agentName === name || agentName.startsWith(`${name} (`))?.brand;
};
const $a4f8945af63a0707$var$ClaudeIcon = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { label: label } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "48",
            height: "48",
            fill: "#D97757"
        });
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M14.2785 29.274L20.5732 25.7445L20.6785 25.4369L20.5732 25.2669H20.2653L19.2122 25.2021L15.6152 25.105L12.4962 24.9755L9.47443 24.8136L8.71291 24.6517L8 23.7126L8.07291 23.2431L8.71291 22.8141L9.62835 22.895L11.6537 23.0326L14.6916 23.2431L16.8952 23.3726L20.16 23.7126H20.6785L20.7514 23.5022L20.5732 23.3726L20.4354 23.2431L17.2922 21.1141L13.8896 18.8636L12.1073 17.5684L11.1433 16.9127L10.6572 16.2975L10.4466 14.9537L11.3215 13.9904L12.4962 14.0713L12.7959 14.1523L13.9868 15.067L16.5306 17.0342L19.8522 19.4789L20.3382 19.8836L20.5327 19.746L20.557 19.6489L20.3382 19.2846L18.5316 16.0223L16.6035 12.7033L15.7448 11.3271L15.518 10.5014C15.437 10.1614 15.3803 9.87807 15.3803 9.52998L16.3767 8.17809L16.9276 8L18.2562 8.17809L18.8152 8.6638L19.6415 10.55L20.9782 13.5209L23.0522 17.5603L23.6597 18.7584L23.9838 19.8674L24.1053 20.2074H24.3159V20.0132L24.4861 17.7384L24.802 14.9456L25.1099 11.3514L25.2152 10.3395L25.7175 9.12522L26.7139 8.46952L27.4916 8.84189L28.1316 9.75664L28.0425 10.3476L27.6618 12.8166L26.9165 16.6861L26.4304 19.2765H26.7139L27.038 18.9527L28.3504 17.2122L30.5539 14.4599L31.5261 13.3671L32.6603 12.1609L33.3894 11.5861H34.7666L35.7792 13.0918L35.3256 14.6461L33.9079 16.4432L32.7332 17.9651L31.0481 20.2317L29.9949 22.045L30.0922 22.1907L30.3433 22.1665L34.1509 21.3569L36.2086 20.9846L38.6633 20.5636L39.7732 21.0817L39.8947 21.6079L39.4572 22.6845L36.8324 23.3322L33.7539 23.9474L29.1686 25.0321L29.1119 25.0726L29.1767 25.1536L31.2425 25.3478L32.1256 25.3964H34.2886L38.3149 25.6959L39.3681 26.3921L40 27.2421L39.8947 27.8897L38.2744 28.7154L36.0871 28.1973L30.9833 26.9831L29.2334 26.5459H28.9904V26.6916L30.4486 28.1164L33.122 30.5287L36.4678 33.6372L36.638 34.4063L36.2086 35.0134L35.7549 34.9486L32.8142 32.7387L31.68 31.743L29.1119 29.5816H28.9418V29.8082L29.5332 30.6744L32.6603 35.3696L32.8223 36.8105L32.5954 37.28L31.7853 37.5634L30.8942 37.4015L29.0633 34.8353L27.1757 31.9454L25.6527 29.3549L25.4663 29.4602L24.5671 39.1338L24.1458 39.6276L23.1737 40L22.3635 39.3848L21.9342 38.3891L22.3635 36.422L22.882 33.8558L23.3033 31.8158L23.6841 29.2821L23.9109 28.4402L23.8947 28.3835L23.7084 28.4078L21.7965 31.0306L18.8881 34.9567L16.5873 37.4177L16.0365 37.6362L15.0805 37.1424L15.1696 36.2601L15.7043 35.4748L18.8881 31.4273L20.8081 28.9178L22.0476 27.4688L22.0395 27.2583H21.9666L13.5089 32.7468L12.002 32.9411L11.3539 32.3339L11.4349 31.3382L11.7428 31.0144L14.2866 29.2659L14.2785 29.274Z",
            fill: "white"
        });
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== label) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: $a4f8945af63a0707$var$SMALL_AVATAR_SIZE,
            height: $a4f8945af63a0707$var$SMALL_AVATAR_SIZE,
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: "img",
            "aria-label": label
        }, t1, t2);
        $[2] = label;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
};
const $a4f8945af63a0707$var$OpenAiIcon = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { label: label } = t0;
    const maskId = (0, $cozmU.useId)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "48",
            height: "48",
            fill: "white"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M39 9H9V39H39V9Z",
            fill: "white"
        });
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== maskId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: maskId,
            "mask-type": "luminance",
            maskUnits: "userSpaceOnUse",
            x: "9",
            y: "9",
            width: "30",
            height: "30"
        }, t2);
        $[2] = maskId;
        $[3] = t3;
    } else t3 = $[3];
    const t4 = `url(#${maskId})`;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M20.5063 19.92V17.0699C20.5063 16.8299 20.5956 16.6498 20.8037 16.53L26.4827 13.23C27.2557 12.78 28.1774 12.5701 29.1287 12.5701C32.6965 12.5701 34.9564 15.3602 34.9564 18.33C34.9564 18.54 34.9564 18.78 34.9266 19.02L29.0395 15.54C28.6828 15.3301 28.3259 15.3301 27.9691 15.54L20.5063 19.92ZM33.7669 31.02V24.2099C33.7669 23.7898 33.5884 23.4898 33.2317 23.2799L25.769 18.8999L28.207 17.4898C28.4151 17.3699 28.5935 17.3699 28.8016 17.4898L34.4806 20.7898C36.116 21.7499 37.2159 23.7898 37.2159 25.7697C37.2159 28.0496 35.8781 30.1497 33.7669 31.0198V31.02ZM18.7522 25.0201L16.3141 23.5802C16.1061 23.4603 16.0168 23.2802 16.0168 23.0401V16.4402C16.0168 13.2303 18.4548 10.8001 21.7552 10.8001C23.0041 10.8001 24.1634 11.2202 25.1448 11.9702L19.2876 15.3903C18.9309 15.6002 18.7525 15.9002 18.7525 16.3203V25.0203L18.7522 25.0201ZM24 28.08L20.5063 26.1V21.9002L24 19.9203L27.4933 21.9002V26.1L24 28.08ZM26.2447 37.2001C24.9959 37.2001 23.8366 36.78 22.8552 36.0301L28.7123 32.61C29.0691 32.4001 29.2475 32.1001 29.2475 31.6799V22.9799L31.7154 24.4198C31.9235 24.5397 32.0128 24.7198 32.0128 24.9599V31.5598C32.0128 34.7697 29.5448 37.1999 26.2447 37.1999V37.2001ZM19.1981 30.5102L13.5191 27.2102C11.8837 26.25 10.7837 24.2102 10.7837 22.2303C10.7837 19.9203 12.1515 17.8503 14.2623 16.9802V23.8202C14.2623 24.2403 14.4408 24.5403 14.7975 24.7502L22.2307 29.1001L19.7927 30.5102C19.5847 30.63 19.4061 30.63 19.1981 30.5102ZM18.8713 35.4301C15.5115 35.4301 13.0436 32.8801 13.0436 29.7301C13.0436 29.4901 13.0734 29.2501 13.103 29.01L18.9602 32.4301C19.3169 32.6401 19.6739 32.6401 20.0306 32.4301L27.4933 28.0803V30.9303C27.4933 31.1703 27.4041 31.3504 27.196 31.4703L21.5171 34.7703C20.744 35.2203 19.8222 35.4301 18.8709 35.4301H18.8713ZM26.2447 39C29.8424 39 32.8452 36.4201 33.5293 33C36.8593 32.1299 39 28.9799 39 25.77C39 23.6699 38.1081 21.63 36.5025 20.16C36.6512 19.5299 36.7404 18.8999 36.7404 18.2701C36.7404 13.9802 33.2914 10.77 29.3072 10.77C28.5046 10.77 27.7315 10.8898 26.9585 11.16C25.6203 9.83994 23.7769 9 21.7552 9C18.1576 9 15.1548 11.5799 14.4707 15C11.1407 15.87 9 19.02 9 22.23C9 24.3301 9.89187 26.3699 11.4975 27.84C11.3488 28.47 11.2596 29.1001 11.2596 29.7299C11.2596 34.0198 14.7086 37.23 18.6927 37.23C19.4954 37.23 20.2685 37.1101 21.0415 36.8399C22.3794 38.16 24.2228 39 26.2447 39Z",
            fill: "black"
        });
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: t4
        }, t5);
        $[5] = t4;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== label || $[8] !== t3 || $[9] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: $a4f8945af63a0707$var$SMALL_AVATAR_SIZE,
            height: $a4f8945af63a0707$var$SMALL_AVATAR_SIZE,
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: "img",
            "aria-label": label
        }, t1, t3, t6);
        $[7] = label;
        $[8] = t3;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    return t7;
};
const $a4f8945af63a0707$export$3b6b7db30cb5c9e7 = (agentName)=>$a4f8945af63a0707$var$getVendorBrand(agentName.trim()) !== undefined;
const $a4f8945af63a0707$export$df5614c444137531 = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { agentName: agentName, fallback: fallback } = t0;
    let t1;
    let trimmedAgentName;
    if ($[0] !== agentName) {
        trimmedAgentName = agentName.trim();
        t1 = $a4f8945af63a0707$var$getVendorBrand(trimmedAgentName);
        $[0] = agentName;
        $[1] = t1;
        $[2] = trimmedAgentName;
    } else {
        t1 = $[1];
        trimmedAgentName = $[2];
    }
    const vendorBrand = t1;
    if (vendorBrand === "claude") {
        let t2;
        if ($[3] !== trimmedAgentName) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a4f8945af63a0707$var$ClaudeIcon, {
                label: trimmedAgentName
            });
            $[3] = trimmedAgentName;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    if (vendorBrand === "chatgpt") {
        let t2;
        if ($[5] !== trimmedAgentName) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a4f8945af63a0707$var$OpenAiIcon, {
                label: trimmedAgentName
            });
            $[5] = trimmedAgentName;
            $[6] = t2;
        } else t2 = $[6];
        return t2;
    }
    return fallback;
};
module.exports["hasAgentVendorIcon"] = $a4f8945af63a0707$export$3b6b7db30cb5c9e7;
module.exports["AgentVendorIcon"] = $a4f8945af63a0707$export$df5614c444137531;

});

parcelRegister("gzxxG", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gVCFw = parcelRequire("gVCFw");


var $lpNn5 = parcelRequire("lpNn5");


var $8EgKx = parcelRequire("8EgKx");


var $iPUfC = parcelRequire("iPUfC");

const $0d8f9945d0ad805e$export$387983f036737d8 = 'ai-suggestion-source-app-stack';
/**
 * Caps how many logos are shown. The design shows two; a third leaves room for a genuinely
 * multi-app suggestion without the stack crowding the row it shares with the Restricted
 * lozenge.
 */ const $0d8f9945d0ad805e$var$MAX_VISIBLE_APPS = 3;
/** Binds an icon to its app for `AppStack`, cached by key so the component identity stays stable. */ const $0d8f9945d0ad805e$var$iconCache = new Map();
const $0d8f9945d0ad805e$var$getAppStackIcon = (app)=>{
    const cached = $0d8f9945d0ad805e$var$iconCache.get(app.key);
    if (cached) return cached;
    const Icon = ()=>{
        const $ = (0, $bDgLe.c)(1);
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iPUfC.SourceAppIcon), {
                app: app,
                size: "xsmall"
            });
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    };
    Icon.displayName = `${app.key}AppStackIcon`;
    $0d8f9945d0ad805e$var$iconCache.set(app.key, Icon);
    return Icon;
};
function $0d8f9945d0ad805e$export$d5f6502df51c1e50(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { sources: sources } = t0;
    const { formatList: formatList, formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== sources) {
        t1 = (0, $iPUfC.getSuggestionSourceApps)(sources);
        $[0] = sources;
        $[1] = t1;
    } else t1 = $[1];
    const sourceApps = t1;
    let t2;
    if ($[2] !== sourceApps) {
        t2 = sourceApps.map($0d8f9945d0ad805e$var$_temp);
        $[2] = sourceApps;
        $[3] = t2;
    } else t2 = $[3];
    const data = t2;
    if (data.length === 0) return null;
    let t3;
    if ($[4] !== formatList || $[5] !== formatMessage || $[6] !== sourceApps) {
        t3 = formatMessage((0, $gVCFw.aiSuggestionsMessages).cardSourceAppsTooltip, {
            apps: formatList(sourceApps.map($0d8f9945d0ad805e$var$_temp2))
        });
        $[4] = formatList;
        $[5] = formatMessage;
        $[6] = sourceApps;
        $[7] = t3;
    } else t3 = $[7];
    const sourceAppsLabel = t3;
    let t4;
    if ($[8] !== data || $[9] !== sourceAppsLabel) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8EgKx.default), {
            data: data,
            size: "xsmall",
            maxCount: $0d8f9945d0ad805e$var$MAX_VISIBLE_APPS,
            label: sourceAppsLabel,
            testId: $0d8f9945d0ad805e$export$387983f036737d8
        });
        $[8] = data;
        $[9] = sourceAppsLabel;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== sourceAppsLabel || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: sourceAppsLabel,
            position: "top",
            ignoreTooltipPointerEvents: true
        }, t4);
        $[11] = sourceAppsLabel;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
}
function $0d8f9945d0ad805e$var$_temp2(t0) {
    const { name: name } = t0;
    return name;
}
function $0d8f9945d0ad805e$var$_temp(app) {
    return {
        component: $0d8f9945d0ad805e$var$getAppStackIcon(app),
        label: ""
    };
}
module.exports["SuggestionItemSourceAppStack"] = $0d8f9945d0ad805e$export$d5f6502df51c1e50;

});

parcelRegister("iPUfC", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $krxYo = parcelRequire("krxYo");


var $9NPFC = parcelRequire("9NPFC");


var $ivSJV = parcelRequire("ivSJV");

const $7f3fba1630e7dac7$var$SOURCE_APP_NAMES = {
    bitbucket: 'Bitbucket',
    confluence: 'Confluence',
    goals: 'Goals',
    home: 'Home',
    jira: 'Jira',
    loom: 'Loom',
    projects: 'Projects',
    slack: 'Slack',
    teams: 'Teams'
};
/** Shared by every unattributed source so they collapse to a single globe in the app stack. */ const $7f3fba1630e7dac7$var$UNATTRIBUTED_KEY = 'unattributed'; /** Hosts whose URLs `getSourceType` may attribute to a named source app. */ 
const $7f3fba1630e7dac7$var$ATTRIBUTED_SOURCE_HOST = /(^|\.)(atlassian\.(net|com|cloud)|bitbucket\.org|loom\.com|slack\.com)$/u;
const $7f3fba1630e7dac7$var$LEADING_WWW = /^www\./u; /** Names an unattributed source by its host, which is the most we can say without resolving it. */ 
const $7f3fba1630e7dac7$var$getHostname = (url)=>{
    try {
        return new URL(url).hostname.replace($7f3fba1630e7dac7$var$LEADING_WWW, '');
    } catch  {
        return null;
    }
}; /** The app a source URL belongs to. Known source apps are attributed; the rest show a globe. */ 
const $7f3fba1630e7dac7$export$911a858a1d74cb31 = (url)=>{
    if (!url) return null;
    const hostname = $7f3fba1630e7dac7$var$getHostname(url);
    if (!hostname) return null;
     // `getSourceType` matches on substrings of the whole URL, so it reads any `/wiki/` path as
    // Confluence, any `/browse/` as Jira, and so on. Checking the host first keeps a link such as
    // `en.wikipedia.org/wiki/Penguin` from being attributed to a named source app.
    if ($7f3fba1630e7dac7$var$ATTRIBUTED_SOURCE_HOST.test(hostname)) {
        const sourceType = (0, $ivSJV.getSourceType)(url);
        if (sourceType !== 'unknown') return {
            key: sourceType,
            Logo: (0, $ivSJV.getLogoForSourceType)(sourceType),
            name: $7f3fba1630e7dac7$var$SOURCE_APP_NAMES[sourceType]
        };
    }
    return {
        key: $7f3fba1630e7dac7$var$UNATTRIBUTED_KEY,
        name: hostname
    };
};
const $7f3fba1630e7dac7$export$10542f0e75dbe131 = (sources)=>{
    // Keyed so each app is kept once. Re-setting a key holds its original position, which is how the
    // globe stays where the first unattributed source appeared once its name is known.
    const apps = new Map();
    const unattributedHosts = new Set();
    for (const { url: url } of sources ?? []){
        const app = $7f3fba1630e7dac7$export$911a858a1d74cb31(url);
        if (!app) continue;
        if (!app.Logo) unattributedHosts.add(app.name);
        if (!apps.has(app.key)) apps.set(app.key, app);
    }
    if (unattributedHosts.size > 0) apps.set($7f3fba1630e7dac7$var$UNATTRIBUTED_KEY, {
        key: $7f3fba1630e7dac7$var$UNATTRIBUTED_KEY,
        name: [
            ...unattributedHosts
        ].join(', ')
    });
    return [
        ...apps.values()
    ];
};
const $7f3fba1630e7dac7$var$styles = {
    logo: "_3iDTPbQ4SZ _26BoRwdnbC"
};
function $7f3fba1630e7dac7$export$12c0736d3fa492e9(t0) {
    const $ = (0, $bDgLe.c)(10);
    const { app: app, size: size } = t0;
    const { Logo: Logo } = app;
    if (Logo) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = (0, $hekY6.default)([
                $7f3fba1630e7dac7$var$styles.logo
            ]);
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] !== Logo || $[2] !== size) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Logo, {
                label: "",
                size: size
            });
            $[1] = Logo;
            $[2] = size;
            $[3] = t2;
        } else t2 = $[3];
        let t3;
        if ($[4] !== t1 || $[5] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                className: t1
            }, t2);
            $[4] = t1;
            $[5] = t2;
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    let t1;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($krxYo))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[7] = t1;
    } else t1 = $[7];
    let t2;
    if ($[8] !== size) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            backgroundColor: "transparent",
            hasBorder: true,
            label: "",
            size: size,
            testId: "ai-suggestion-source-globe"
        }, t1);
        $[8] = size;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
}
module.exports["getSourceApp"] = $7f3fba1630e7dac7$export$911a858a1d74cb31;
module.exports["getSuggestionSourceApps"] = $7f3fba1630e7dac7$export$10542f0e75dbe131;
module.exports["SourceAppIcon"] = $7f3fba1630e7dac7$export$12c0736d3fa492e9;

});

parcelRegister("cQk6K", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gVCFw = parcelRequire("gVCFw");


var $aZ9If = parcelRequire("aZ9If");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $l8wPz = parcelRequire("l8wPz");


var $4yYAm = parcelRequire("4yYAm");


var $jdA6O = parcelRequire("jdA6O");


var $hSqtY = parcelRequire("hSqtY");


var $iPUfC = parcelRequire("iPUfC");

const $8a1270699a77db0d$var$cardUiOptions = {
    clickableContainer: true,
    hideBackground: true,
    hideElevation: true,
    hidePadding: true,
    size: (0, $4yYAm.SmartLinkSize).Medium,
    theme: (0, $4yYAm.SmartLinkTheme).Black
}; // ---------------------------------------------------------------------------
// Styles
// ---------------------------------------------------------------------------
const $8a1270699a77db0d$var$styles = {
    sourcesContainer: "_4bt5LAYvD1 _2WAcuGYvD1 _2mHwu82ADO _39xV02N91d _4ouGXIdnbC _3iDTPbQ4SZ _0aFT5vbt8w",
    sourceLabel: "_2Y7lL48HPE",
    sourceCard: "_4bt5LAYvD1 _2WAcuGYvD1 _2Y7lL48HPE _1mT5xdRAKS _39xV02N91d _24h04i2Njc _4ouGXIdnbC _4kiQYAkG2W",
    cardLoading: "_4bt5LAnQyn _2WAcuGnQyn _0fKRyPnQyn _0jFU0VkG2W",
    skeletonOverlay: "_49OCfRPgdg _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1pp6NdYbGa"
}; // ---------------------------------------------------------------------------
// Skeleton shown while the smart card is resolving
// ---------------------------------------------------------------------------
function $8a1270699a77db0d$var$SourceSkeleton() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                $8a1270699a77db0d$var$styles.skeletonOverlay
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "65%",
            height: 12,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} // ---------------------------------------------------------------------------
// SourceCard — renders the smart card with a skeleton overlay while loading
// ---------------------------------------------------------------------------
function $8a1270699a77db0d$var$SourceCard(t0) {
    const $ = (0, $bDgLe.c)(21);
    const { url: url } = t0;
    const [status, setStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState("loading");
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setStatus("resolved");
        $[0] = t1;
    } else t1 = $[0];
    const handleResolve = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setStatus("errored");
        $[1] = t2;
    } else t2 = $[1];
    const handleError = t2;
    if (status === "errored") return null;
    let t3;
    if ($[2] !== url) {
        t3 = (0, $iPUfC.getSourceApp)(url);
        $[2] = url;
        $[3] = t3;
    } else t3 = $[3];
    const app = t3;
    const t4 = status === "loading" && $8a1270699a77db0d$var$styles.cardLoading;
    let t5;
    if ($[4] !== t4) {
        t5 = (0, $hekY6.default)([
            t4
        ]);
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== app) {
        t6 = app ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iPUfC.SourceAppIcon), {
            app: app,
            size: "xxsmall"
        }) : undefined;
        $[6] = app;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.TitleBlock), {
            maxLines: 1,
            anchorTarget: "_blank",
            icon: t6
        });
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t7 || $[11] !== url) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
            appearance: "inline",
            ui: $8a1270699a77db0d$var$cardUiOptions,
            url: url,
            onResolve: handleResolve,
            onError: handleError
        }, t7);
        $[10] = t7;
        $[11] = url;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== t5 || $[14] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t5
        }, t8);
        $[13] = t5;
        $[14] = t8;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== status) {
        t10 = status === "loading" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a1270699a77db0d$var$SourceSkeleton, null);
        $[16] = status;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== t10 || $[19] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t9, t10);
        $[18] = t10;
        $[19] = t9;
        $[20] = t11;
    } else t11 = $[20];
    return t11;
}
function $8a1270699a77db0d$var$SuggestionItemSourcesInner(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { sources: sources } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let unique;
    if ($[0] !== sources) {
        unique = new Set();
        for (const { url: url } of sources)if (url) unique.add(url);
        $[0] = sources;
        $[1] = unique;
    } else unique = $[1];
    let t1;
    if ($[2] !== unique) {
        t1 = Array.from(unique);
        $[2] = unique;
        $[3] = t1;
    } else t1 = $[3];
    const urls = t1;
    if (urls.length === 0) return null;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $8a1270699a77db0d$var$styles.sourcesContainer
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ9If))), {
            label: "",
            size: "medium",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $gVCFw.aiSuggestionsMessages).teamworkGraphLabel);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $8a1270699a77db0d$var$styles.sourceLabel,
            space: "space.100",
            alignBlock: "center"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "span",
            color: "color.text.subtle",
            size: "medium",
            weight: "medium"
        }, t4));
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== urls) {
        t6 = urls.map($8a1270699a77db0d$var$_temp);
        $[10] = urls;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t2 || $[13] !== t5 || $[14] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t2
        }, t5, t6);
        $[12] = t2;
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    return t7;
} // ---------------------------------------------------------------------------
// Public export — wrapped in TransparentErrorBoundary so that unexpected
// errors (e.g. missing SmartCardProvider context in tests) render nothing
// rather than crashing the whole suggestions panel.
// ---------------------------------------------------------------------------
function $8a1270699a77db0d$var$_temp(url_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        key: url_0,
        className: (0, $hekY6.default)([
            $8a1270699a77db0d$var$styles.sourceCard
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a1270699a77db0d$var$SourceCard, {
        url: url_0
    }));
}
function $8a1270699a77db0d$export$a64427a030c80b66(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { sources: sources } = t0;
    if (!sources.length) return null;
    let t1;
    if ($[0] !== sources) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: "suggestions-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a1270699a77db0d$var$SuggestionItemSourcesInner, {
            sources: sources
        }));
        $[0] = sources;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
}
module.exports["SuggestionItemSources"] = $8a1270699a77db0d$export$a64427a030c80b66;

});

parcelRegister("3Kj0o", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $2217c019964fe119$var$expandSecondCard = null;
const $2217c019964fe119$var$expandThirdCard = null;
const $2217c019964fe119$var$fadeBackingShadow = null;
const $2217c019964fe119$var$styles = {
    stack: "_2mHwu85zaO _1mT5xdRAKS _3iDTPbQ4SZ _0aFT5vbt8w",
    card: "_0bjKvDyzSk _1mT5xdRAKS _0yKXXafPTf",
    frontCard: "_42Yu6B7LI7 _1gBibyshgJ",
    frontSelectedCard: "_1gBibyYbGa",
    secondCard: "_1gBibyzvVR _42Yu6BiZR3",
    secondSelectedCard: "_1gBibyoFdq",
    thirdCard: "_1gBibyUckG _42Yu6B7dHp",
    thirdSelectedCard: "_1gBibyIv9F",
    hiddenCard: "_1gBibyKJOJ _42Yu6BdnbC",
    entering: "_0nFVCGpCLV _1jakNnqvoi _43vdfTjwM9 _3Y6bKp38c8 _0adGzLxlqh _3aRm2exlqh"
};
const $2217c019964fe119$export$5fd9474a5f0fef8c = (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { children: children, isAnimating: isAnimating, onAnimationComplete: onAnimationComplete } = t0;
    const stackRef = (0, $cozmU.useRef)(null);
    const [positions, setPositions] = (0, $cozmU.useState)();
    let t1;
    let t2;
    if ($[0] !== isAnimating || $[1] !== onAnimationComplete) {
        t1 = ()=>{
            if (!isAnimating) {
                setPositions(undefined);
                return;
            }
            const cards = stackRef.current?.children;
            if (!cards || cards.length < 2) {
                onAnimationComplete();
                return;
            }
            const firstCard = cards[0];
            if (!(firstCard instanceof HTMLElement)) return;
            const firstCardHeight = firstCard.offsetHeight;
            const initialPositions = new Map();
            Array.from(cards).forEach((card)=>{
                if (!(card instanceof HTMLElement) || !card.dataset.stackId) return;
                initialPositions.set(card.dataset.stackId, {
                    offset: `${-card.offsetTop}px`,
                    heightRatio: card.offsetHeight > 0 ? firstCardHeight / card.offsetHeight : 1
                });
            });
            setPositions(initialPositions);
        };
        t2 = [
            isAnimating,
            onAnimationComplete
        ];
        $[0] = isAnimating;
        $[1] = onAnimationComplete;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[4] !== onAnimationComplete) {
        t3 = (event)=>{
            if (event.nativeEvent.pseudoElement || event.target.parentElement !== stackRef.current) return;
            setPositions(undefined);
            onAnimationComplete();
        };
        $[4] = onAnimationComplete;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $2217c019964fe119$var$styles.stack
        ]);
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== children || $[8] !== positions) {
        let t6;
        if ($[10] !== positions) {
            t6 = (child, index)=>{
                const isSelected = child.props.isSelected;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    key: child.key,
                    "data-stack-id": String(child.key),
                    style: {
                        "--stack-offset": positions?.get(String(child.key))?.offset,
                        "--stack-height-ratio": positions?.get(String(child.key))?.heightRatio
                    },
                    className: (0, $hekY6.default)([
                        $2217c019964fe119$var$styles.card,
                        positions?.has(String(child.key)) && $2217c019964fe119$var$styles.entering,
                        positions?.has(String(child.key)) && index === 0 && $2217c019964fe119$var$styles.frontCard,
                        positions?.has(String(child.key)) && index === 1 && $2217c019964fe119$var$styles.secondCard,
                        positions?.has(String(child.key)) && index === 2 && $2217c019964fe119$var$styles.thirdCard,
                        positions?.has(String(child.key)) && index > 2 && $2217c019964fe119$var$styles.hiddenCard,
                        positions?.has(String(child.key)) && isSelected && index === 0 && $2217c019964fe119$var$styles.frontSelectedCard,
                        positions?.has(String(child.key)) && isSelected && index === 1 && $2217c019964fe119$var$styles.secondSelectedCard,
                        positions?.has(String(child.key)) && isSelected && index === 2 && $2217c019964fe119$var$styles.thirdSelectedCard
                    ])
                }, child);
            };
            $[10] = positions;
            $[11] = t6;
        } else t6 = $[11];
        t5 = children.map(t6);
        $[7] = children;
        $[8] = positions;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[12] !== t3 || $[13] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: stackRef,
            onAnimationEnd: t3,
            className: t4
        }, t5);
        $[12] = t3;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
};
module.exports["SuggestionsStack"] = $2217c019964fe119$export$5fd9474a5f0fef8c;

});

parcelRegister("5kr5S", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $bQm3c = parcelRequire("bQm3c");


var $73rWB = parcelRequire("73rWB");


var $71PZp = parcelRequire("71PZp");


var $jPGwc = parcelRequire("jPGwc");


var $kFMd1 = parcelRequire("kFMd1");

const $b7e604ba0168687b$var$i18n = (0, $kSwu1.defineMessages)({
    discardAll: {
        id: "suggestions-panel.footer.discard-all",
        defaultMessage: "Discard all"
    }
});
const $b7e604ba0168687b$var$styles = {
    footer: "_2mHwu81Y8M _4c065U1Y8M _2Y7lL4kG2W _24h04i2Njc _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _1mT5xdRAKS _42Yu6B7dHp _39xV02N91d",
    scrim: "_1mT5xdWVPG _2I62gzUgYP _1ZB6UydnbC _3iC0zddnbC _1OKFqYdnbC _42Yu6BvQQr _3CkH9o65Q8"
}; /**
    * This component is only used under platform_editor_ai_content_suggested_edits
    * at the moment.
    */ 
const $b7e604ba0168687b$export$48c2d7e975592083 = ()=>{
    const $ = (0, $bDgLe.c)(18);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { suggestions: suggestions, editorAPI: editorAPI } = (0, $jPGwc.useSuggestionsSource)();
    const [t0] = (0, $71PZp.useSuggestionsPanelFilters)();
    const { currentFilter: currentFilter } = t0;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== currentFilter || $[1] !== suggestions || $[2] !== userId) {
        t1 = (0, $73rWB.filterSuggestions)(suggestions, currentFilter, userId);
        $[0] = currentFilter;
        $[1] = suggestions;
        $[2] = userId;
        $[3] = t1;
    } else t1 = $[3];
    const visibleSuggestions = t1;
    let t2;
    if ($[4] !== currentFilter || $[5] !== editorAPI?.aiSuggestions?.actions || $[6] !== visibleSuggestions) {
        t2 = ()=>{
            if (!visibleSuggestions.length) return;
            const actions = editorAPI?.aiSuggestions?.actions;
            if (currentFilter === (0, $73rWB.SuggestionFilterValues).ALL) actions?.discardAllSuggestions();
            else actions?.discardAllSuggestions(visibleSuggestions.map($b7e604ba0168687b$var$_temp));
        };
        $[4] = currentFilter;
        $[5] = editorAPI?.aiSuggestions?.actions;
        $[6] = visibleSuggestions;
        $[7] = t2;
    } else t2 = $[7];
    const handleDiscardAll = t2;
    let t3;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $b7e604ba0168687b$var$styles.footer
        ]);
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                $b7e604ba0168687b$var$styles.scrim
            ])
        });
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== editorAPI || $[11] !== formatMessage || $[12] !== handleDiscardAll || $[13] !== visibleSuggestions.length) {
        t5 = editorAPI && visibleSuggestions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            shouldFitContainer: true,
            onClick: handleDiscardAll
        }, formatMessage($b7e604ba0168687b$var$i18n.discardAll));
        $[10] = editorAPI;
        $[11] = formatMessage;
        $[12] = handleDiscardAll;
        $[13] = visibleSuggestions.length;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kFMd1.AiPolicyFooter), null);
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("footer", {
            "data-testid": "suggestions-panel-footer",
            className: t3
        }, t4, t5, t6);
        $[16] = t5;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
};
function $b7e604ba0168687b$var$_temp(t0) {
    const { id: id } = t0;
    return id;
}
module.exports["SuggestionsFooter"] = $b7e604ba0168687b$export$48c2d7e975592083;

});

parcelRegister("kFMd1", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gVCFw = parcelRequire("gVCFw");


var $9KSWX = parcelRequire("9KSWX");


var $7vK9E = parcelRequire("7vK9E");


var $1l0kj = parcelRequire("1l0kj");

const $9f4c24b8aa4ead43$var$DEFAULT_DISCLAIMER_URL = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $9f4c24b8aa4ead43$var$styles = {
    link: "_2sNsIg7NXe _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzKGUX _2nTuUYKGUX _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMKGUX"
}; /**
    * AI policy footer for the suggestions side panel.
    *
    * Renders: [info icon] "Uses AI. Verify results." [link-out icon] [Labs lozenge]
    * where the link-out icon links to the Atlassian Intelligence disclaimer page.
    * Both the disclaimer and Labs lozenge are centred as a group.
    *
    * Copied from platform/packages/editor/editor-plugin-ai-suggestions/src/ui/components/SuggestionCard/SuggestionCardFooter.tsx
    */ 
function $9f4c24b8aa4ead43$export$4d02d06ac0fb885f() {
    const $ = (0, $bDgLe.c)(11);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $gVCFw.aiSuggestionsMessages).cardDisclaimerText);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
            href: $9f4c24b8aa4ead43$var$DEFAULT_DISCLAIMER_URL,
            target: "_blank",
            rel: "noopener noreferrer",
            xcss: $9f4c24b8aa4ead43$var$styles.link
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            as: "span"
        }, t0)));
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage((0, $gVCFw.aiSuggestionsMessages).labsLozengeLabel);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
            appearance: "discovery"
        }, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            alignInline: "center"
        }, t1, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
}
module.exports["AiPolicyFooter"] = $9f4c24b8aa4ead43$export$4d02d06ac0fb885f;

});

parcelRegister("cQTQm", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4nIKB = parcelRequire("4nIKB");


var $78t8C = parcelRequire("78t8C");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $aGFDz = parcelRequire("aGFDz");


var $gVrmv = parcelRequire("gVrmv");


var $6TaGl = parcelRequire("6TaGl");


var $4u3xL = parcelRequire("4u3xL");


var $djfAu = parcelRequire("djfAu");


var $mMS8X = parcelRequire("mMS8X");


var $jPGwc = parcelRequire("jPGwc");


var $hhCf5 = parcelRequire("hhCf5");

const $c31e5246566476f5$var$i18n = (0, $kSwu1.defineMessages)({
    moreActions: {
        id: "suggestions-panel.header.more-actions",
        defaultMessage: "More actions"
    },
    // Replaces the retired `header.review-again` ("Review again") message rather than
    // rewording it, so any in-flight translations of the old string can just be dropped.
    review: {
        id: "suggestions-panel.header.review",
        defaultMessage: "Review"
    },
    giveFeedback: {
        id: "suggestions-panel.header.give-feedback",
        defaultMessage: "Give feedback"
    }
});
const $c31e5246566476f5$export$98880ae4e85ffa61 = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { count: count } = (0, $jPGwc.useSuggestionsSource)();
    let t0;
    if ($[0] !== count) {
        t0 = count > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $78t8C.default), {
            max: false
        }, count) : null;
        $[0] = count;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $c31e5246566476f5$export$b6797be1e70cc63 = ()=>{
    const $ = (0, $bDgLe.c)(29);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isThinking: isThinking, editorAPI: editorAPI } = (0, $jPGwc.useSuggestionsSource)();
    const isOffline = (0, $djfAu.useIsOffline)(editorAPI);
    const actions = editorAPI?.aiSuggestions?.actions;
    const feedback = (0, $mMS8X.useSuggestionsFeedback)();
    let t0;
    if ($[0] !== feedback.triggerRef || $[1] !== formatMessage) {
        t0 = (t1)=>{
            const { triggerRef: triggerRef, ...triggerProps } = t1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                ref: (0, $4nIKB.mergeRefs)([
                    triggerRef,
                    feedback.triggerRef
                ]),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: formatMessage($c31e5246566476f5$var$i18n.moreActions),
                isTooltipDisabled: false,
                appearance: "subtle",
                spacing: "default"
            });
        };
        $[0] = feedback.triggerRef;
        $[1] = formatMessage;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gVrmv))), {
            label: ""
        });
        $[3] = t1;
    } else t1 = $[3];
    const t2 = feedback.open;
    const t3 = feedback.triggerRef;
    let t4;
    if ($[4] !== formatMessage) {
        t4 = formatMessage($c31e5246566476f5$var$i18n.giveFeedback);
        $[4] = formatMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== feedback.open || $[7] !== feedback.triggerRef || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            elemBefore: t1,
            onClick: t2,
            returnFocusRef: t3
        }, t4));
        $[6] = feedback.open;
        $[7] = feedback.triggerRef;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t0 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            placement: "bottom-end",
            trigger: t0
        }, t5);
        $[10] = t0;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== formatMessage) {
        t7 = formatMessage($c31e5246566476f5$var$i18n.review);
        $[13] = formatMessage;
        $[14] = t7;
    } else t7 = $[14];
    const t8 = isThinking || isOffline;
    let t9;
    if ($[15] !== actions) {
        t9 = ()=>actions?.setThinkingState("thinking", {
                entryPoint: (0, $aGFDz.AiSuggestionsEntryPointValue).SUGGESTIONS_PANEL_HEADER
            });
        $[15] = actions;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4u3xL))),
            label: t7,
            isDisabled: t8,
            isTooltipDisabled: false,
            appearance: "subtle",
            spacing: "default",
            onClick: t9
        });
        $[17] = t7;
        $[18] = t8;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== feedback.close || $[22] !== feedback.isOpen || $[23] !== feedback.triggerRef) {
        t11 = feedback.isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hhCf5.SuggestionsFeedbackCollectorLoader), {
            onClose: feedback.close,
            shouldReturnFocusRef: feedback.triggerRef
        });
        $[21] = feedback.close;
        $[22] = feedback.isOpen;
        $[23] = feedback.triggerRef;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t10 || $[26] !== t11 || $[27] !== t6) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6, t10, t11);
        $[25] = t10;
        $[26] = t11;
        $[27] = t6;
        $[28] = t12;
    } else t12 = $[28];
    return t12;
};
module.exports["SuggestionsCount"] = $c31e5246566476f5$export$98880ae4e85ffa61;
module.exports["SuggestionsHeaderActions"] = $c31e5246566476f5$export$b6797be1e70cc63;

});

parcelRegister("mMS8X", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $0a8dc55a9d46e020$export$6143b35f8e6c9e00 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const triggerRef = (0, $cozmU.useRef)(null);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>setIsOpen(true);
        $[0] = t0;
    } else t0 = $[0];
    const open = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setIsOpen(false);
            triggerRef.current?.focus();
        };
        $[1] = t1;
    } else t1 = $[1];
    const close = t1;
    let t2;
    if ($[2] !== isOpen) {
        t2 = {
            isOpen: isOpen,
            open: open,
            close: close,
            triggerRef: triggerRef
        };
        $[2] = isOpen;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
module.exports["useSuggestionsFeedback"] = $0a8dc55a9d46e020$export$6143b35f8e6c9e00;

});

parcelRegister("hhCf5", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $jmjWc = parcelRequire("jmjWc");

const $747debc11ff45c70$var$LoadingFeedback = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { error: error, onClose: onClose } = t0;
    let t1;
    let t2;
    if ($[0] !== error || $[1] !== onClose) {
        t1 = ()=>{
            if (error) onClose();
        };
        t2 = [
            error,
            onClose
        ];
        $[0] = error;
        $[1] = onClose;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
};

const $747debc11ff45c70$var$LazySuggestionsFeedbackCollector = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "RnpTQ",
    name: "LazySuggestionsFeedbackCollector",
    loader: async ()=>(await (parcelRequire("k2Q2M"))).SuggestionsFeedbackCollector,
    // Loadable reports import failures itself; this exposes them to the local close/reset handler.
    isReactLoadable: true,
    loading: $747debc11ff45c70$var$LoadingFeedback
});
const $747debc11ff45c70$export$b1b9687a4389a7dd = (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($747debc11ff45c70$var$LazySuggestionsFeedbackCollector, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.onClose || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).CC_EDITOR_AI,
            onError: props.onClose
        }, t0);
        $[2] = props.onClose;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};
module.exports["SuggestionsFeedbackCollectorLoader"] = $747debc11ff45c70$export$b1b9687a4389a7dd;

});

parcelRegister("k2Q2M", function(module, exports) {

let $e97c5d5cb32a6cc3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e97c5d5cb32a6cc3$var$load("ba8tC").then(()=>parcelRequire('j9E42'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("4u4Rn", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");


var $jPGwc = parcelRequire("jPGwc");


var $aBKnh = parcelRequire("aBKnh");


var $cQTQm = parcelRequire("cQTQm");

const $13f5f557e2b765b9$export$41a5a764b7e0667 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    const { mode: mode } = (0, $jPGwc.useSuggestionsSource)();
    if (mode === "published") return null;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cQTQm.SuggestionsHeaderActions), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aBKnh.SuggestionsFilterMenu), null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["SuggestionsHeaderActionGroup"] = $13f5f557e2b765b9$export$41a5a764b7e0667;

});

parcelRegister("aBKnh", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $1LOGx = parcelRequire("1LOGx");


var $2gVZP = parcelRequire("2gVZP");


var $73rWB = parcelRequire("73rWB");


var $71PZp = parcelRequire("71PZp");

const $7ba1257da32cd3ab$var$i18n = (0, $kSwu1.defineMessages)({
    filterAndSortLabel: {
        id: "suggestions-panel.header.filter-and-sort.label",
        defaultMessage: "Filter and sort suggestions"
    },
    filterTitle: {
        id: "suggestions-panel.header.filter.title",
        defaultMessage: "Filter"
    },
    filterAll: {
        id: "suggestions-panel.header.filter.all",
        defaultMessage: "All suggestions"
    },
    filterCreatedByMe: {
        id: "suggestions-panel.header.filter.created-by-me",
        defaultMessage: "Created by me"
    },
    sortTitle: {
        id: "suggestions-panel.header.sort.title",
        defaultMessage: "Sort"
    },
    sortTopToBottom: {
        id: "suggestions-panel.header.sort.top-to-bottom",
        defaultMessage: "Top \u2192 Bottom"
    },
    sortNewToOld: {
        id: "suggestions-panel.header.sort.new-to-old",
        defaultMessage: "New \u2192 Old"
    }
});
const $7ba1257da32cd3ab$var$filterOptions = [
    {
        value: (0, $73rWB.SuggestionFilterValues).ALL,
        label: $7ba1257da32cd3ab$var$i18n.filterAll
    },
    {
        value: (0, $73rWB.SuggestionFilterValues).CREATED_BY_ME,
        label: $7ba1257da32cd3ab$var$i18n.filterCreatedByMe
    }
];
const $7ba1257da32cd3ab$var$sortOptions = [
    {
        value: (0, $73rWB.SuggestionSortValues).TOP_TO_BOTTOM,
        label: $7ba1257da32cd3ab$var$i18n.sortTopToBottom
    },
    {
        value: (0, $73rWB.SuggestionSortValues).NEW_TO_OLD,
        label: $7ba1257da32cd3ab$var$i18n.sortNewToOld
    }
];
const $7ba1257da32cd3ab$var$FILTER_ICON_TEST_ID = 'suggestions-panel-filter-icon';
function $7ba1257da32cd3ab$var$DefaultFilterIcon(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1LOGx))), {
            ...props,
            testId: $7ba1257da32cd3ab$var$FILTER_ICON_TEST_ID
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
}
/**
 * `IconButton`'s own `isSelected` state doesn't render for this trigger (see the same note in
 * `CommentsPanelFilterMenu`), so a non-default filter or sort is conveyed with a tinted icon
 * instead.
 *
 * Noting: this only reaches sighted users. The selection itself stays available to assistive
 * technology through the menu items' selected state.
 */ function $7ba1257da32cd3ab$var$SelectedFilterIcon(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1LOGx))), {
            ...props,
            color: "var(--ds-icon-selected, #1868DB)",
            testId: $7ba1257da32cd3ab$var$FILTER_ICON_TEST_ID
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
}
/** Own component so each option keeps a stable `onClick` instead of one built per render. */ const $7ba1257da32cd3ab$var$MenuOption = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { isSelected: isSelected, label: label, onSelect: onSelect, testId: testId, value: value } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== onSelect || $[1] !== value) {
        t1 = ()=>onSelect(value);
        $[0] = onSelect;
        $[1] = value;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    let t2;
    if ($[3] !== formatMessage || $[4] !== label) {
        t2 = formatMessage(label);
        $[3] = formatMessage;
        $[4] = label;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== handleClick || $[7] !== isSelected || $[8] !== t2 || $[9] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            isSelected: isSelected,
            onClick: handleClick,
            testId: testId
        }, t2);
        $[6] = handleClick;
        $[7] = isSelected;
        $[8] = t2;
        $[9] = testId;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
};
const $7ba1257da32cd3ab$export$5a54f31f30f31fbc = ()=>{
    const $ = (0, $bDgLe.c)(29);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [t0, t1] = (0, $71PZp.useSuggestionsPanelFilters)();
    const { currentFilter: currentFilter, currentSort: currentSort } = t0;
    const { setCurrentFilter: setCurrentFilter, setCurrentSort: setCurrentSort } = t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== setCurrentFilter) {
        t2 = (filter)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: (0, $2gVZP.SUGGESTIONS_PANEL_ANALYTICS_SOURCE),
                    action: "clicked",
                    actionSubject: "menuItem",
                    actionSubjectId: "suggestionsPanelFilter",
                    attributes: {
                        filter: filter
                    }
                }
            }).fire();
            setCurrentFilter(filter);
        };
        $[0] = createAnalyticsEvent;
        $[1] = setCurrentFilter;
        $[2] = t2;
    } else t2 = $[2];
    const handleFilterClick = t2;
    let t3;
    if ($[3] !== createAnalyticsEvent || $[4] !== setCurrentSort) {
        t3 = (sort)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: (0, $2gVZP.SUGGESTIONS_PANEL_ANALYTICS_SOURCE),
                    action: "clicked",
                    actionSubject: "menuItem",
                    actionSubjectId: "suggestionsPanelSort",
                    attributes: {
                        sort: sort
                    }
                }
            }).fire();
            setCurrentSort(sort);
        };
        $[3] = createAnalyticsEvent;
        $[4] = setCurrentSort;
        $[5] = t3;
    } else t3 = $[5];
    const handleSortClick = t3;
    const isDefaultFilterState = currentFilter === (0, $73rWB.SuggestionFilterValues).ALL && currentSort === (0, $73rWB.SuggestionSortValues).TOP_TO_BOTTOM;
    let t4;
    if ($[6] !== formatMessage || $[7] !== isDefaultFilterState) {
        t4 = (t5)=>{
            const { triggerRef: triggerRef, ...triggerProps } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                ref: triggerRef,
                appearance: "subtle",
                spacing: "default",
                icon: isDefaultFilterState ? $7ba1257da32cd3ab$var$DefaultFilterIcon : $7ba1257da32cd3ab$var$SelectedFilterIcon,
                isTooltipDisabled: false,
                label: formatMessage($7ba1257da32cd3ab$var$i18n.filterAndSortLabel),
                testId: "suggestions-panel-filter-button"
            });
        };
        $[6] = formatMessage;
        $[7] = isDefaultFilterState;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($7ba1257da32cd3ab$var$i18n.filterTitle);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== currentFilter || $[12] !== handleFilterClick) {
        t6 = $7ba1257da32cd3ab$var$filterOptions.map((t7)=>{
            const { value: value, label: label } = t7;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7ba1257da32cd3ab$var$MenuOption, {
                key: value,
                isSelected: value === currentFilter,
                label: label,
                onSelect: handleFilterClick,
                testId: `suggestions-panel-filter-${value}`,
                value: value
            });
        });
        $[11] = currentFilter;
        $[12] = handleFilterClick;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== t5 || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), {
            id: "filter",
            title: t5
        }, t6);
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== formatMessage) {
        t8 = formatMessage($7ba1257da32cd3ab$var$i18n.sortTitle);
        $[17] = formatMessage;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== currentSort || $[20] !== handleSortClick) {
        t9 = $7ba1257da32cd3ab$var$sortOptions.map((t10)=>{
            const { value: value_0, label: label_0 } = t10;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7ba1257da32cd3ab$var$MenuOption, {
                key: value_0,
                isSelected: value_0 === currentSort,
                label: label_0,
                onSelect: handleSortClick,
                testId: `suggestions-panel-sort-${value_0}`,
                value: value_0
            });
        });
        $[19] = currentSort;
        $[20] = handleSortClick;
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== t8 || $[23] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), {
            id: "sort",
            title: t8
        }, t9);
        $[22] = t8;
        $[23] = t9;
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    if ($[25] !== t10 || $[26] !== t4 || $[27] !== t7) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            placement: "bottom-end",
            spacing: "compact",
            shouldRenderToParent: true,
            testId: "suggestions-panel-filter-menu",
            trigger: t4
        }, t7, t10);
        $[25] = t10;
        $[26] = t4;
        $[27] = t7;
        $[28] = t11;
    } else t11 = $[28];
    return t11;
};
module.exports["SuggestionsFilterMenu"] = $7ba1257da32cd3ab$export$5a54f31f30f31fbc;

});


//# sourceMappingURL=MediaViewerCommentSidebar.56535df3.js.map
